/*
 * サブシステム名
 * 機能名：受注・実績登録
 */
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import flowMixin from '@/mixins/flowMixins'
import complements from '@/rahmen/complement'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import date from '@/ddv2.library/date'
import d2fmt from '@/ddv2.library/utils/formatter'
import fraction from '@/ddv2.library/fraction'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdJitsuUnsoTaiseiKanriEdit from '@/components/DdJitsuUnsoTaiseiKanriEdit'

const DdCalcDistance = () => import('@/components/DdCalcDistance.vue')
const DdCalcTankaButton = () => import('@/components/DdCalcTankaButton.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdPackageTeikeiCourseSearchTextBox = () => import('@/components/DdPackageTeikeiCourseSearchTextBox')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBox = () => import('@/components/DdTimeBox')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdJuchuHimozukeSearchButton = () => import('@/components/DdJuchuHimozukeSearchButton')
const DdJuchuRirekiSearchButton = () => import('@/components/DdJuchuRirekiSearchButton')

export default {
  name: 'HaisoMeisaiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdFooterButton,
    DdCalcDistance,
    DdCalcTankaButton,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDataTable,
    DdDateBox,
    DdDefaultButton,
    DdDropDown,
    DdEditDialog,
    DdEditCommonBar,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdJuchuHimozukeSearchButton,
    DdJuchuRirekiSearchButton,
    DdJitsuUnsoTaiseiKanriEdit,
    DdSectionTitle,
    DdSubHeader,
    DdSwitch,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdTimeBox,
    DdTimeBoxSwitching,
    DdPackageTeikeiCourseSearchTextBox
  },
  data: () => ({
    id: 0,
    baseYmd: '',
    keikakujissekikey: '',
    trJuchuKihonId: 0,
    haishaEigyoshoCd: '',
    jiEigyoshoId: 0,
    dispJisshaRitsu: 0,
    meisaiCount: 0,
    nenryoCount: 0,
    tsukoryoCount: 0,
    jishaSharyoSbt: null,
    yoshaSharyoSbt: null,
    activeTab: '01',
    invalidMessages: {},
    // ----------------------------------------------------------------------------------------------------
    // 必須制御
    // ----------------------------------------------------------------------------------------------------
    isRequiredCommon: true,
    isRequiredJomuin: false,
    isRequiredJoshu: false,
    isRequiredSharyo: false,
    isRequiredYosha: false,
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    viewsData: {
      vwUnkoJisseki: {},
      vwSagyoJisseki: {},
      vwKintaiJissekiJomuin: {},
      vwKintaiJissekiJoshu: {},
      vwHaisoMeisai: [{}],
      trSagyoKeikakuJininList: [{}],
      trSagyoKeikakuMeisaiList: [{}],
      vwSharyoKeihiNenryohi: [{}],
      vwSharyoKeihiTsukoryo: [{}]
    },
    tempViewsData: {},
    /*
     * 乗務員・車両情報編集用定義
     */
    jomuinKinmuTeateKingakuAmount: 0,
    joshuKinmuTeateKingakuAmount: 0,
    lastUnkoJissekiInfo: {},
    /*
     * 配送明細編集用定義
     */
    recTokuisakiInfo: {},
    recHaisoMeisai: {},
    tempHaisoMeisai: {},
    /*
     * 経費編集画面用定義
     */
    recNenryo: {},
    tempNenryo: {},
    recTsukoryo: {},
    tempTsukoryo: {},
    // ----------------------------------------------------------------------------------------------------
    // タブ定義
    // ----------------------------------------------------------------------------------------------------
    tab: [
      { href: '#tab1', value: '配送明細' },
      { href: '#tab2', value: '燃料' },
      { href: '#tab3', value: '通行料' }
    ],
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    registerMode: 0,
    deleteMode: 0,
    messageLessMode: 0,
    readOnlyMode: false,
    modeKengen: 2, // 0:読み取り専用,1:削除不可,2:フルアクセス
    modeOfEdit: 0,
    haisoMeisaiEditIndex: -1,
    nenryoEditIndex: -1,
    tsukoryoEditIndex: -1,
    isJishaHaishaMode: true,
    isJiEigyoshoMode: true,
    isHokaEigyoshoMode: false,
    isHaisoMeisaiRequired: true,
    yoshaSharyoSwitch: false,
    hinmeiSwitch: false,
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    expandKeiyuchi: false,
    CancelButtonDisp: true,
    DeleteButtonDisp: false,
    NewButtonDisp: true,
    kakuninzumiMode: false,
    seikyuZumiMode: false,
    shiharaiZumiMode: false,
    initializeMode: true,
    // ----------------------------------------------------------------------------------------------------
    // データテーブル用定義
    // ----------------------------------------------------------------------------------------------------
    haisoMeisaiListHeaders: [],
    nenryohiListHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '', value: 'selectRow' },
      { text: 'No', value: 'tekiyo5' },
      { text: '車両経費No', value: 'sharyoKeihiNo' },
      { text: '給油所', value: 'wTorihikisakiCdNm' },
      { text: '燃料名', value: 'wFuelKbnNm' },
      { text: '給油量', value: 'suryo', align: 'right' },
      { text: '単価', value: 'keihiTanka', align: 'right' },
      { text: '金額', value: 'keihiKingaku', align: 'right' },
      { text: '給油時オド', value: 'odoMater', align: 'right' },
      { text: '支払方法', value: 'wShiharaiKbnNm' },
      { text: 'カード番号', value: 'tekiyo4' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ],
    tsukoryoListHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '', value: 'selectRow' },
      { text: 'No', value: 'tekiyo5' },
      { text: '車両経費No', value: 'sharyoKeihiNo' },
      { text: '入口料金所', value: 'tekiyo1' },
      { text: '出口料金所', value: 'tekiyo2' },
      { text: '回数', value: 'suryo', align: 'right' },
      { text: '金額', value: 'keihiKingaku', align: 'right' },
      { text: '支払方法', value: 'wShiharaiKbnNm' },
      { text: 'カード番号', value: 'tekiyo4' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ]
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      usersId: 'users/userId',
      currentKaishaCode: 'users/currentKaishaCode',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      teikeiCourseList: 'DDMasters/vwCD2mstd0460',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const self = this
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn !== '03' && t.eigyoshoCd === self.usersEigyosho
      })
    },
    filteredEigyoshoGroupJininList () {
      const self = this
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn !== '03' && (self.eigyoshoLockFlg || t.eigyoshoCd === this.haishaEigyoshoCd)
      })
    },
    filteredYoshaJininList () {
      const self = this
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn === '03'
      })
    },
    // 人員マスタフィルター <-- ここまで
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const self = this
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const self = this
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const self = this
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === true
      })
    },
    filteredMstShiiresakiList () {
      const self = this
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.shiiresakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      return this.filteredMstSharyo.filter((t) => {
        // return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === false && t.eigyoshoCd === self.haishaEigyoshoCd
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === false && t.eigyoshoCd === this.haishaEigyoshoCd
      })
    },
    filteredMstYoshaSharyoList () {
      const self = this
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const self = this
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 品名マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const self = this
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 就労区分フィルター
    filteredShuroKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF999')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 燃料区分フィルター
    filteredNenryoKubunList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    },
    // 支払種別フィルター
    filteredShiharaiShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT021')
    },
    // 往復種別フィルター
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    // 課税区分
    filteredKazeiKbnList () {
      return this.sbtListFilterForDropDownItem(this.kubunList, 'SFF059')
    },
    // 端数処理区分
    filteredHasuKeisanKbnList () {
      return this.sbtListFilterForDropDownItem(this.kubunList, 'SFF060')
    },
    // 配送明細フィルター --> ここから
    filteredHaisoMeisaiListRows () {
      // データがない場合の制御
      if (!this.viewsData.vwHaisoMeisai.map) { return }

      const self = this
      return this.viewsData.vwHaisoMeisai.map((elem) => {
        var unitKbnNm = ''
        if (![undefined, null, ''].includes(elem.unitKbn)) {
          var unitRec = self.filteredUnitKbnList.filter((item) => {
            return elem.unitKbn === item.value
          })
          if (unitRec.length > 0) {
            unitKbnNm = unitRec[0].text
          }
        }

        // 基本運賃
        let amount = 0
        let kihonUnchin = 0
        const tanka = ![undefined, null].includes(elem.tanka) ? elem.tanka : 0
        if (elem.unchinKeisanKbn === '01') {
          let juchuSuryo = elem.juchuSuryo
          if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }
          juchuSuryo = d2fmt.removeComma(juchuSuryo)
          kihonUnchin = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
        } else if (elem.unchinKeisanKbn === '02') {
          let juchuJuryo = elem.juchuJuryo
          if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }
          juchuJuryo = d2fmt.removeComma(juchuJuryo)
          kihonUnchin = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
        } else if (elem.unchinKeisanKbn === '03') {
          kihonUnchin = parseFloat(tanka, 10)
        }
        amount += kihonUnchin
        if (elem.unchinHokaKingaku) { amount += parseFloat(elem.unchinHokaKingaku, 10) }
        if (elem.hokanKingaku) { amount += parseFloat(elem.hokanKingaku, 10) }
        if (elem.niekiKingaku) { amount += parseFloat(elem.niekiKingaku, 10) }
        if (elem.hiwayPrice) { amount += parseFloat(elem.hiwayPrice, 10) }
        if (elem.nenryoSurcharge) { amount += parseFloat(elem.nenryoSurcharge, 10) }
        if (elem.tsumikomiKingaku) { amount += parseFloat(elem.tsumikomiKingaku, 10) }
        if (elem.torioroshiKingaku) { amount += parseFloat(elem.torioroshiKingaku, 10) }
        if (elem.taikiJikanKingaku) { amount += parseFloat(elem.taikiJikanKingaku, 10) }
        if (elem.futaiGyomuKingaku) { amount += parseFloat(elem.futaiGyomuKingaku, 10) }
        if (elem.futaiGyomuKingaku1) { amount += parseFloat(elem.futaiGyomuKingaku1, 10) }
        if (elem.futaiGyomuKingaku2) { amount += parseFloat(elem.futaiGyomuKingaku2, 10) }
        if (elem.futaiGyomuKingaku3) { amount += parseFloat(elem.futaiGyomuKingaku3, 10) }
        if (elem.futaiGyomuKingaku4) { amount += parseFloat(elem.futaiGyomuKingaku4, 10) }
        if (elem.futaiGyomuKingaku5) { amount += parseFloat(elem.futaiGyomuKingaku5, 10) }
        if (elem.futaiGyomuKingaku6) { amount += parseFloat(elem.futaiGyomuKingaku6, 10) }
        if (elem.futaiGyomuKingaku7) { amount += parseFloat(elem.futaiGyomuKingaku7, 10) }
        if (elem.futaiGyomuKingaku8) { amount += parseFloat(elem.futaiGyomuKingaku8, 10) }
        if (elem.futaiGyomuKingaku9) { amount += parseFloat(elem.futaiGyomuKingaku9, 10) }
        if (elem.futaiGyomuKingaku10) { amount += parseFloat(elem.futaiGyomuKingaku10, 10) }
        if (elem.unchinHokaHikazei) { amount += parseFloat(elem.unchinHokaHikazei, 10) }
        if (elem.tatekaekinHikazei) { amount += parseFloat(elem.tatekaekinHikazei, 10) }
        if (elem.jikanWarimashiKingaku) { amount += parseFloat(elem.jikanWarimashiKingaku, 10) }
        if (elem.kyoriWarimashiKingaku) { amount += parseFloat(elem.kyoriWarimashiKingaku, 10) }
        if (elem.warimashiSonotaKingsku) { amount += parseFloat(elem.warimashiSonotaKingsku, 10) }

        if (elem.meisaiOrder) { elem.meisaiOrder = Number(elem.meisaiOrder) }
        if (elem.tokuisakiId) { elem.dispTokuisaki = indexeddb.getRecord(this.torihikisakiList, elem.tokuisakiId).torihikisakiCd + ':' + indexeddb.getRecord(this.torihikisakiList, elem.tokuisakiId).torihikisakiNm }
        if (elem.hatsuchiId) { elem.dispHatsuchi = indexeddb.getRecord(this.hacchakuchiList, elem.hatsuchiId).hacchakuchiCd + ':' + indexeddb.getRecord(this.hacchakuchiList, elem.hatsuchiId).hacchakuchiNm }
        if (!elem.hatsuchiId && elem.hatsuchiBiko) { elem.dispHatsuchi = elem.hatsuchiBiko }
        if (elem.hatsuchiYmd || elem.hatsuchiHms) { elem.dispHatsuchiYmd = !elem.hatsuchiYmd ? elem.hatsuchiHms : !elem.hatsuchiHms ? elem.hatsuchiYmd : elem.hatsuchiYmd.slice(-8) + ' ' + elem.hatsuchiHms }
        if (elem.hatsuchiHmsBiko && !(elem.hatsuchiYmd || elem.hatsuchiHms)) { elem.dispHatsuchiYmd = elem.hatsuchiHmsBiko }
        if (elem.chakuchiId) { elem.dispChakuchi = indexeddb.getRecord(this.hacchakuchiList, elem.chakuchiId).hacchakuchiCd + ':' + indexeddb.getRecord(this.hacchakuchiList, elem.chakuchiId).hacchakuchiNm }
        if (!elem.chakuchiId && elem.chakuchiBiko) { elem.dispChakuchi = elem.chakuchiBiko }
        if (elem.chakuchiYmd || elem.chakuchiHms) { elem.dispChakuchiYmd = !elem.chakuchiYmd ? elem.chakuchiHms : !elem.chakuchiHms ? elem.chakuchiYmd : elem.chakuchiYmd.slice(-8) + ' ' + elem.chakuchiHms }
        if (elem.chakuchiHmsBiko && !(elem.chakuchiYmd || elem.chakuchiHms)) { elem.dispChakuchiYmd = elem.chakuchiHmsBiko }
        if (!elem.mstHinmeiId && elem.hinmeiBiko) { elem.dispHinmei = elem.hinmeiBiko }
        if (elem.mstHinmeiId) { elem.dispHinmei = indexeddb.getRecord(this.hinmeiList, elem.mstHinmeiId).hinmeiCd + ':' + indexeddb.getRecord(this.hinmeiList, elem.mstHinmeiId).hinmeiNm }
        if (elem.juchuSuryo) { elem.dispJuchuSuryo = filter.numericMinorDigitFormatter(elem.juchuSuryo, 3) }
        if (elem.unitKbn) { elem.dispUnitKbnNm = unitKbnNm }
        if (elem.juchuJuryo) { elem.dispJuchuJuryo = filter.numericMinorDigitFormatter(elem.juchuJuryo, 3) }
        if (elem.tanka) { elem.dispTanka = filter.numericMinorDigitFormatter(elem.tanka, 0) }
        elem.dispKihonUnchin = filter.numericMinorDigitFormatter(kihonUnchin, 0)
        if (elem.hiwayPrice) { elem.dispHiwayPrice = filter.numericMinorDigitFormatter(elem.hiwayPrice, 0) }
        elem.dispUnchinGokei = filter.numericMinorDigitFormatter(amount, 0)
        elem.dispChumonshoReceiveZumiFlg = elem.chumonshoReceiveZumiFlg ? '受領済' : ''
        elem.dispChumonkakuninshoSendZumiFlg = elem.chumonkakuninshoSendZumiFlg ? '送付済' : ''
        elem.dispHacchushoSendZumiFlg = elem.hacchushoSendZumiFlg ? '送付済' : ''
        elem.dispMotoukeHokokuZumiFlg = elem.motoukeHokokuZumiFlg ? '報告済' : ''
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      })
    },
    filteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        elem.keiyuchiId2Disp = elem.keiyuchiId2 ? elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm : elem.keiyuchiId2Biko
        elem.keiyuchiId3Disp = elem.keiyuchiId3 ? elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm : elem.keiyuchiId3Biko
        elem.keiyuchiId4Disp = elem.keiyuchiId4 ? elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm : elem.keiyuchiId4Biko
        elem.keiyuchiId5Disp = elem.keiyuchiId5 ? elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm : elem.keiyuchiId5Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.hokanKingaku) { elem.hokanKingaku = filter.numericFormatter(elem.hokanKingaku) }
        if (elem.niekiKingaku) { elem.niekiKingaku = filter.numericFormatter(elem.niekiKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        if (elem.futaiGyomuKingaku1) { elem.futaiGyomuKingaku1 = filter.numericFormatter(elem.futaiGyomuKingaku1) }
        if (elem.futaiGyomuKingaku2) { elem.futaiGyomuKingaku2 = filter.numericFormatter(elem.futaiGyomuKingaku2) }
        if (elem.futaiGyomuKingaku3) { elem.futaiGyomuKingaku3 = filter.numericFormatter(elem.futaiGyomuKingaku3) }
        if (elem.futaiGyomuKingaku4) { elem.futaiGyomuKingaku4 = filter.numericFormatter(elem.futaiGyomuKingaku4) }
        if (elem.futaiGyomuKingaku5) { elem.futaiGyomuKingaku5 = filter.numericFormatter(elem.futaiGyomuKingaku5) }
        if (elem.futaiGyomuKingaku6) { elem.futaiGyomuKingaku6 = filter.numericFormatter(elem.futaiGyomuKingaku6) }
        if (elem.futaiGyomuKingaku7) { elem.futaiGyomuKingaku7 = filter.numericFormatter(elem.futaiGyomuKingaku7) }
        if (elem.futaiGyomuKingaku8) { elem.futaiGyomuKingaku8 = filter.numericFormatter(elem.futaiGyomuKingaku8) }
        if (elem.futaiGyomuKingaku9) { elem.futaiGyomuKingaku9 = filter.numericFormatter(elem.futaiGyomuKingaku9) }
        if (elem.futaiGyomuKingaku10) { elem.futaiGyomuKingaku10 = filter.numericFormatter(elem.futaiGyomuKingaku10) }
        if (elem.tatekaekinHikazei) { elem.tatekaekinHikazei = filter.numericFormatter(elem.tatekaekinHikazei) }
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) }
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + ' km' : null
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.sagyoinTeateKingaku1) { elem.sagyoinTeateKingaku1 = filter.numericFormatter(elem.sagyoinTeateKingaku1) }
        if (elem.sharyoKeihiHiwayEtc) { elem.sharyoKeihiHiwayEtc = filter.numericFormatter(elem.sharyoKeihiHiwayEtc) }
        if (elem.sharyoKeihiHiwayGenkin) { elem.sharyoKeihiHiwayGenkin = filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) }
        if (elem.sharyoKeihiFerry) { elem.sharyoKeihiFerry = filter.numericFormatter(elem.sharyoKeihiFerry) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    },
    // 配送明細フィルター <-- ここまで
    // 燃料行データ
    nenryohiRows () {
      // データがない場合の制御
      if (!this.viewsData.vwSharyoKeihiNenryohi) return

      return this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
        if (elem.tekiyo5) { elem.tekiyo5 = Number(elem.tekiyo5) }

        if (elem.torihikisakiId) {
          elem.wTorihikisakiCdNm = indexeddb.getRecord(this.torihikisakiList, elem.torihikisakiId).torihikisakiCd + ':' + indexeddb.getRecord(this.torihikisakiList, elem.torihikisakiId).torihikisakiNm
        }
        if (elem.fuelKbn) {
          elem.wFuelKbnNm = elem.fuelKbnNm !== -1 ? elem.fuelKbn + ' : ' + indexeddb.getKubun(this.currentKaishaCode, this.kubunList, 'SFF053', elem.fuelKbn).codeNm : ''
        }
        if (elem.tekiyo3) {
          elem.wShiharaiKbnNm = elem.shiharaiKbnNm !== -1 ? elem.tekiyo3 + ' : ' + indexeddb.getShubetsu(this.currentKaishaCode, this.shubetsuList, 'SBT021', elem.tekiyo3).sbtNm : ''
        }
        if (elem.suryo) {
          elem.suryo = filter.numericFormatter(String(elem.suryo))
        }
        if (elem.keihiTanka) {
          elem.keihiTanka = filter.numericFormatter(String(elem.keihiTanka))
        }
        if (elem.keihiKingaku) {
          elem.keihiKingaku = filter.numericFormatter(String(elem.keihiKingaku))
        }
        if (elem.odoMater) {
          elem.odoMater = filter.numericFormatter(String(elem.odoMater))
        }
        return elem
      }).sort((a, b) => {
        if (a.tekiyo5 > b.tekiyo5) { return 1 }
        if (a.tekiyo5 === b.tekiyo5) { return 0 }
        return -1
      })
    },
    // 通行料行データ
    tsukoryoRows () {
      // データがない場合の制御
      if (!this.viewsData.vwSharyoKeihiTsukoryo) return

      return this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
        if (elem.tekiyo5) { elem.tekiyo5 = Number(elem.tekiyo5) }

        if (elem.tekiyo3) {
          elem.wShiharaiKbnNm = elem.shiharaiKbnNm !== -1 ? elem.tekiyo3 + ' : ' + indexeddb.getShubetsu(this.currentKaishaCode, this.shubetsuList, 'SBT021', elem.tekiyo3).sbtNm : ''
        }
        if (elem.suryo) {
          elem.suryo = filter.numericFormatter(String(elem.suryo))
        }
        if (elem.keihiKingaku) {
          elem.keihiKingaku = filter.numericFormatter(String(elem.keihiKingaku))
        }

        return elem
      }).sort((a, b) => {
        if (a.tekiyo5 > b.tekiyo5) { return 1 }
        if (a.tekiyo5 === b.tekiyo5) { return 0 }
        return -1
      })
    },
    calcJisshaRitsu () {
      let rate = 0
      let sokoKyori = this.viewsData.vwUnkoJisseki.sokoKyori
      let jisshaKyori = this.viewsData.vwUnkoJisseki.jisshaKyori

      if (sokoKyori === undefined || sokoKyori === '' || sokoKyori === null) { sokoKyori = 0 }
      if (jisshaKyori === undefined || jisshaKyori === '' || jisshaKyori === null) { jisshaKyori = 0 }

      if (sokoKyori === 0) { return rate }

      rate = (parseInt(jisshaKyori * 10, 10) / parseInt(sokoKyori * 10, 10)) * 100
      rate = rate === 0 ? 0 : Math.round(rate * 10) / 10

      return rate
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.recHaisoMeisai.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.recHaisoMeisai.unchinKeisanKbn === '01') {
        let juchuSuryo = this.recHaisoMeisai.juchuSuryo
        if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }
        juchuSuryo = d2fmt.removeComma(juchuSuryo)
        amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
      } else if (this.recHaisoMeisai.unchinKeisanKbn === '02') {
        let juchuJuryo = this.recHaisoMeisai.juchuJuryo
        if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }
        juchuJuryo = d2fmt.removeComma(juchuJuryo)
        amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
      } else if (this.recHaisoMeisai.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }
      amount = this.calcFraction(amount)

      return amount
    },
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hokanKingaku = this.recHaisoMeisai.hokanKingaku
      let niekiKingaku = this.recHaisoMeisai.niekiKingaku
      let unchinHokaKingaku = this.recHaisoMeisai.unchinHokaKingaku

      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (niekiKingaku === undefined || niekiKingaku === '' || niekiKingaku === null) { niekiKingaku = '0' }
      if (unchinHokaKingaku === undefined || unchinHokaKingaku === '' || unchinHokaKingaku === null) { unchinHokaKingaku = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) + parseInt(hokanKingaku, 10) + parseInt(niekiKingaku, 10) + parseInt(unchinHokaKingaku, 10)

      return amount
    },
    futaiGyomuKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let futaiGyomuKingaku1 = this.recHaisoMeisai.futaiGyomuKingaku1
      let futaiGyomuKingaku2 = this.recHaisoMeisai.futaiGyomuKingaku2
      let futaiGyomuKingaku3 = this.recHaisoMeisai.futaiGyomuKingaku3
      let futaiGyomuKingaku4 = this.recHaisoMeisai.futaiGyomuKingaku4
      let futaiGyomuKingaku5 = this.recHaisoMeisai.futaiGyomuKingaku5
      let futaiGyomuKingaku6 = this.recHaisoMeisai.futaiGyomuKingaku6
      let futaiGyomuKingaku7 = this.recHaisoMeisai.futaiGyomuKingaku7
      let futaiGyomuKingaku8 = this.recHaisoMeisai.futaiGyomuKingaku8
      let futaiGyomuKingaku9 = this.recHaisoMeisai.futaiGyomuKingaku9
      let futaiGyomuKingaku10 = this.recHaisoMeisai.futaiGyomuKingaku10
      let futaiGyomuKingaku = this.recHaisoMeisai.futaiGyomuKingaku

      if (futaiGyomuKingaku1 === undefined || futaiGyomuKingaku1 === '' || futaiGyomuKingaku1 === null) { futaiGyomuKingaku1 = '0' }
      if (futaiGyomuKingaku2 === undefined || futaiGyomuKingaku2 === '' || futaiGyomuKingaku2 === null) { futaiGyomuKingaku2 = '0' }
      if (futaiGyomuKingaku3 === undefined || futaiGyomuKingaku3 === '' || futaiGyomuKingaku3 === null) { futaiGyomuKingaku3 = '0' }
      if (futaiGyomuKingaku4 === undefined || futaiGyomuKingaku4 === '' || futaiGyomuKingaku4 === null) { futaiGyomuKingaku4 = '0' }
      if (futaiGyomuKingaku5 === undefined || futaiGyomuKingaku5 === '' || futaiGyomuKingaku5 === null) { futaiGyomuKingaku5 = '0' }
      if (futaiGyomuKingaku6 === undefined || futaiGyomuKingaku6 === '' || futaiGyomuKingaku6 === null) { futaiGyomuKingaku6 = '0' }
      if (futaiGyomuKingaku7 === undefined || futaiGyomuKingaku7 === '' || futaiGyomuKingaku7 === null) { futaiGyomuKingaku7 = '0' }
      if (futaiGyomuKingaku8 === undefined || futaiGyomuKingaku8 === '' || futaiGyomuKingaku8 === null) { futaiGyomuKingaku8 = '0' }
      if (futaiGyomuKingaku9 === undefined || futaiGyomuKingaku9 === '' || futaiGyomuKingaku9 === null) { futaiGyomuKingaku9 = '0' }
      if (futaiGyomuKingaku10 === undefined || futaiGyomuKingaku10 === '' || futaiGyomuKingaku10 === null) { futaiGyomuKingaku10 = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }

      let amount = 0

      amount = parseInt(futaiGyomuKingaku1, 10) +
                parseInt(futaiGyomuKingaku2, 10) +
                parseInt(futaiGyomuKingaku3, 10) +
                parseInt(futaiGyomuKingaku4, 10) +
                parseInt(futaiGyomuKingaku5, 10) +
                parseInt(futaiGyomuKingaku6, 10) +
                parseInt(futaiGyomuKingaku7, 10) +
                parseInt(futaiGyomuKingaku8, 10) +
                parseInt(futaiGyomuKingaku9, 10) +
                parseInt(futaiGyomuKingaku10, 10) +
                parseInt(futaiGyomuKingaku, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hiwayPrice = this.recHaisoMeisai.hiwayPrice
      let unchinHokaHikazei = this.recHaisoMeisai.unchinHokaHikazei
      let tatekaekinHikazei = this.recHaisoMeisai.tatekaekinHikazei

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (unchinHokaHikazei === undefined || unchinHokaHikazei === '' || unchinHokaHikazei === null) { unchinHokaHikazei = '0' }
      if (tatekaekinHikazei === undefined || tatekaekinHikazei === '' || tatekaekinHikazei === null) { tatekaekinHikazei = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(unchinHokaHikazei, 10) + parseInt(tatekaekinHikazei, 10)

      return amount
    },
    warimashiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let jikanWarimashiKingaku = this.recHaisoMeisai.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.recHaisoMeisai.kyoriWarimashiKingaku
      let warimashiSonotaKingsku = this.recHaisoMeisai.warimashiSonotaKingsku

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (warimashiSonotaKingsku === undefined || warimashiSonotaKingsku === '' || warimashiSonotaKingsku === null) { warimashiSonotaKingsku = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(warimashiSonotaKingsku, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10) + parseInt(this.futaiGyomuKingakuAmount, 10)

      return amount
    },
    calcSeikyuKingakuAmount () {
      let amount = 0
      // const hasuKeisanKbn = this.recTokuisakiInfo.unchinHasuKeisanKbn ? this.recTokuisakiInfo.unchinHasuKeisanKbn : '02'

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
        // amount = this.hikazeiKingakuAmount + tax.calcTaxToIncluded(this.unchinAddWarimashiKingakuAmout, hasuKeisanKbn, new Date())
      }

      return amount
    },
    // 処理中作業明細IDリスト
    selectedTrSagyoMeisaiIds () {
      const tsmIdList = [
        ...(this.viewsData?.vwHaisoMeisai ?? []).map(x => x.tsmId),
        this.recHaisoMeisai?.tsmId
      ].filter(v => v != null && v !== '')

      return tsmIdList
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.kakuninzumiMode && !this.seikyuZumiMode && !this.shiharaiZumiMode && this.id > 0) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2 && this.id > 0) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyKakuninzumiFlg () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode || this.readOnlyMode) {
        return true
      }
      return false
    },
    isReadOnlySeikyuzumi () {
      if ((this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode || this.recHaisoMeisai.seikyuZumiFlg) && this.activeTab === '01') {
        return true
      }
      return false
    },
    isReadOnlyShiharaizumi () {
      if ((this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode || this.recHaisoMeisai.shiharaiZumiFlg) && this.activeTab === '01') {
        return true
      }
      return false
    },
    isReadOnlyKeihi () {
      if (this.isReadOnlyBase || this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        return true
      }
      return false
    },
    isMapUsable () {
      if ((this.recHaisoMeisai.hatsuchiId) ||
          (this.recHaisoMeisai.keiyuchiId1) ||
          (this.recHaisoMeisai.keiyuchiId2) ||
          (this.recHaisoMeisai.keiyuchiId3) ||
          (this.recHaisoMeisai.keiyuchiId4) ||
          (this.recHaisoMeisai.keiyuchiId5) ||
          (this.recHaisoMeisai.chakuchiId)) {
        return true
      }
      return false
    }
  },
  created () {
    // 遷移元情報
    // this.setFromParameters(this.$route.params.id)
  },
  mounted () {
    this.initialize()
  },
  watch: {
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        viewsData: this.viewsData,
        recHaisoMeisai: this.recHaisoMeisai,
        recNenryo: this.recNenryo,
        recTsukoryo: this.recTsukoryo,
        meisaiCount: this.meisaiCount,
        nenryoCount: this.nenryoCount,
        tsukoryoCount: this.tsukoryoCount
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        let path = ''
        if (self.id > 0) {
          path = `/api/v1/D2PRMD0020/JuchuWithJissekiSearch?id=${self.id}`
        } else {
          path = `/api/v1/D2PRMD0020/InitJuchuWithJissekiGetbyKeikakuInfo?key=${self.keikakujissekikey}`
        }
        self.HttpClient
          .get(path)
          .then((data) => {
            if (data.payload) {
              const inputData = {}
              inputData.vwUnkoJisseki = data.payload.vwUnkoJisseki
              self.id = inputData.vwUnkoJisseki.id
              inputData.vwSagyoJisseki = data.payload.vwSagyoJisseki
              self.kakuninzumiMode = Boolean(inputData.vwSagyoJisseki.jissekiKakuninZumiFlg)
              if (data.payload.vwKintaiJissekiJomuin) {
                inputData.vwKintaiJissekiJomuin = data.payload.vwKintaiJissekiJomuin
                if (inputData.vwKintaiJissekiJomuin.kosokuJikan !== null && inputData.vwKintaiJissekiJomuin.kosokuJikan !== undefined) {
                  inputData.vwKintaiJissekiJomuin.kosokuJikan = String(data.payload.vwKintaiJissekiJomuin.kosokuJikan)
                }
                if (inputData.vwKintaiJissekiJomuin.zangyoJikan !== null && inputData.vwKintaiJissekiJomuin.zangyoJikan !== undefined) {
                  inputData.vwKintaiJissekiJomuin.zangyoJikan = String(data.payload.vwKintaiJissekiJomuin.zangyoJikan)
                }
                if (inputData.vwKintaiJissekiJomuin.shinyaJikan !== null && inputData.vwKintaiJissekiJomuin.shinyaJikan !== undefined) {
                  inputData.vwKintaiJissekiJomuin.shinyaJikan = String(data.payload.vwKintaiJissekiJomuin.shinyaJikan)
                }
                if (inputData.vwKintaiJissekiJomuin.shinyaZangyoJikan !== null && inputData.vwKintaiJissekiJomuin.shinyaZangyoJikan !== undefined) {
                  inputData.vwKintaiJissekiJomuin.shinyaZangyoJikan = String(data.payload.vwKintaiJissekiJomuin.shinyaZangyoJikan)
                }
                if (inputData.vwKintaiJissekiJomuin.kyukeiJikan !== null && inputData.vwKintaiJissekiJomuin.kyukeiJikan !== undefined) {
                  inputData.vwKintaiJissekiJomuin.kyukeiJikan = String(data.payload.vwKintaiJissekiJomuin.kyukeiJikan)
                }
              } else {
                inputData.vwKintaiJissekiJomuin = {
                  jininId: '',
                  shuroKbn: null,
                  kosokuJikan: null,
                  zangyoJikan: null,
                  shinyaJikan: null,
                  shinyaZangyoJikan: null,
                  kyukeiJikan: null,
                  kinmuTeateKingaku1: null,
                  kinmuTeateKingaku2: null,
                  kinmuTeateKingaku3: null,
                  kinmuTeateKingaku4: null,
                  kinmuTeateKingaku5: null,
                  kinmuTeateKingaku6: null,
                  kinmuTeateKingaku7: null,
                  kinmuTeateKingaku8: null
                }
              }
              if (data.payload.vwKintaiJissekiJoshu) {
                inputData.vwKintaiJissekiJoshu = data.payload.vwKintaiJissekiJoshu
                if (inputData.vwKintaiJissekiJoshu.kosokuJikan !== null && inputData.vwKintaiJissekiJoshu.kosokuJikan !== undefined) {
                  inputData.vwKintaiJissekiJoshu.kosokuJikan = String(data.payload.vwKintaiJissekiJoshu.kosokuJikan)
                }
                if (inputData.vwKintaiJissekiJoshu.zangyoJikan !== null && inputData.vwKintaiJissekiJoshu.zangyoJikan !== undefined) {
                  inputData.vwKintaiJissekiJoshu.zangyoJikan = String(data.payload.vwKintaiJissekiJoshu.zangyoJikan)
                }
                if (inputData.vwKintaiJissekiJoshu.shinyaJikan !== null && inputData.vwKintaiJissekiJoshu.shinyaJikan !== undefined) {
                  inputData.vwKintaiJissekiJoshu.shinyaJikan = String(data.payload.vwKintaiJissekiJoshu.shinyaJikan)
                }
                if (inputData.vwKintaiJissekiJoshu.shinyaZangyoJikan !== null && inputData.vwKintaiJissekiJoshu.shinyaZangyoJikan !== undefined) {
                  inputData.vwKintaiJissekiJoshu.shinyaZangyoJikan = String(data.payload.vwKintaiJissekiJoshu.shinyaZangyoJikan)
                }
                if (inputData.vwKintaiJissekiJoshu.kyukeiJikan !== null && inputData.vwKintaiJissekiJoshu.kyukeiJikan !== undefined) {
                  inputData.vwKintaiJissekiJoshu.kyukeiJikan = String(data.payload.vwKintaiJissekiJoshu.kyukeiJikan)
                }
              } else {
                inputData.vwKintaiJissekiJoshu = {
                  jininId: '',
                  shuroKbn: null,
                  kosokuJikan: null,
                  zangyoJikan: null,
                  shinyaJikan: null,
                  shinyaZangyoJikan: null,
                  kyukeiJikan: null,
                  kinmuTeateKingaku1: null,
                  kinmuTeateKingaku2: null,
                  kinmuTeateKingaku3: null,
                  kinmuTeateKingaku4: null,
                  kinmuTeateKingaku5: null,
                  kinmuTeateKingaku6: null,
                  kinmuTeateKingaku7: null,
                  kinmuTeateKingaku8: null
                }
              }
              if (data.payload.vwHaisoMeisai) {
                self.meisaiCount = data.payload.meisaiCount
                inputData.vwHaisoMeisai = data.payload.vwHaisoMeisai
                var seikyuZumi = inputData.vwHaisoMeisai.find((t) => {
                  return t.seikyuZumiFlg === true
                })
                self.seikyuZumiMode = Boolean(seikyuZumi)

                var shiharaiZumi = inputData.vwHaisoMeisai.find((t) => {
                  return t.shiharaiZumiFlg === true
                })
                self.shiharaiZumiMode = Boolean(shiharaiZumi)

                inputData.vwHaisoMeisai.forEach((elem) => {
                  elem.dispJitsuUnsoTaiseiKanriList = Object.assign([], elem.jitsuUnsoTaiseiKanriList)
                })
              } else {
                inputData.vwHaisoMeisai = []
              }
              if (data.payload.trSagyoKeikakuJininList) {
                inputData.trSagyoKeikakuJininList = data.payload.trSagyoKeikakuJininList
              } else {
                inputData.trSagyoKeikakuJininList = []
              }
              if (data.payload.trSagyoKeikakuMeisaiList) {
                inputData.trSagyoKeikakuMeisaiList = data.payload.trSagyoKeikakuMeisaiList
              } else {
                inputData.trSagyoKeikakuMeisaiList = []
              }
              if (data.payload.vwSharyoKeihiNenryohi) {
                self.nenryoCount = data.payload.nenryoCount
                inputData.vwSharyoKeihiNenryohi = data.payload.vwSharyoKeihiNenryohi
              } else {
                inputData.vwSharyoKeihiNenryohi = []
              }
              if (data.payload.vwSharyoKeihiTsukoryo) {
                self.tsukoryoCount = data.payload.tsukoryoCount
                inputData.vwSharyoKeihiTsukoryo = data.payload.vwSharyoKeihiTsukoryo
              } else {
                inputData.vwSharyoKeihiTsukoryo = []
              }
              self.viewsData = Object.assign({}, inputData)
              self.inputOdoMater()
              self.inputJissekiKyori()
              self.calcTeateKingaku(0)
              self.calcTeateKingaku(1)
              self.convertToDispType().then(() => {
                self.calcJikanWarimashiKingaku()
                self.calcKyoriWarimashiKingaku()
                self.cloneData = dolly.clone(self.getCloneTargetMethod())
              })
              /*
              self.tab = '#tab1'
              self.activeTab = '01'
              */
              const selectedTab = self.activeTab
              self.activeTab = '01'
              if (self.viewsData.vwHaisoMeisai.length > 0) {
                const selectedHaisiMeisai = self.viewsData.vwHaisoMeisai.filter(function (elem) {
                  return elem.id === Number(self.trJuchuKihonId)
                })
                if (selectedHaisiMeisai.length > 0) {
                  self.onMeisaiEditOpenButtonClick(selectedHaisiMeisai[0])
                } else {
                  self.onMeisaiEditOpenButtonClick(self.viewsData.vwHaisoMeisai[0])
                }
              }
              self.activeTab = '02'
              if (self.viewsData.vwSharyoKeihiNenryohi.length > 0) {
                self.onMeisaiEditOpenButtonClick(self.viewsData.vwSharyoKeihiNenryohi[0])
              }
              self.activeTab = '03'
              if (self.viewsData.vwSharyoKeihiTsukoryo.length > 0) {
                self.onMeisaiEditOpenButtonClick(self.viewsData.vwSharyoKeihiTsukoryo[0])
              }
              self.activeTab = selectedTab
              /*
              self.recNenryo = {}
              self.recNenryo.torihikisakiId = null
              self.recTsukoryo = {}
              */
              self.baseYmd = self.viewsData.vwUnkoJisseki.unkoYmd
            } else {
              self.id = 0
              self.keikakujissekikey = '0'
              self.trJuchuKihonId = 0
              self.setInvalidSummaryMessage('COMI0101')
            }
            if (self.seikyuZumiMode) {
              self.setInvalidSummaryMessage('RCOI0006')
            }
            if (!self.seikyuZumiMode && self.shiharaiZumiMode) {
              self.setInvalidSummaryMessage('PLOI0006')
            }
            resolve()
          })
      })
    },
    initialize () {
      this.setFromParameters(this.$route.params.id).then((e) => {
        const self = this
        const option = {
          loadMasters: ['vwcmsteigyoshojininlist', 'msteigyosho', 'msttorihikisaki', 'vwcmstsharyo', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu', 'vwcd2mstd0460'],
          initializeInputPromise: () => {
            return new Promise((resolve) => {
              self.initBindVariables()
              console.log('initializeInputPromise')
              resolve()
            })
          },
          savedInputRestorePromise: (c) => {
            return new Promise((resolve) => {
              // ユーザ保存項目の復元
              if (self.custoMizeSavedInputRestore) {
                self.custoMizeSavedInputRestore(c)
              } else {
                self.rec = { ...self.rec, ...c }
              }
              resolve()
            })
          },
          existsIdMethod: () => {
            return !(self.id === 0 && self.keikakujissekikey === '0')
          },
          requestApiPromise: self.fetchData,
          settingButtonStatePromise: (kengen) => {
            return new Promise((resolve) => {
              console.log('settingButtonStatePromise', kengen)
              if (kengen.kengenKbn === '10' || kengen.kengenKbn === '0') {
                // 読取モード
                self.modeKengen = 0
              } else if (kengen.kengenKbn === '20') {
                // 削除不可モード
                self.modeKengen = 1
              } else {
                // フルアクセス
                self.modeKengen = 2
              }
              // thisId == 0 then 新規モード
              if (self.id === 0) {
                self.modeOfEdit = 0 // 新規モード
              } else if (self.modeKengen === 0) {
                self.modeOfEdit = 1 // 照会モード
              } else {
                self.modeOfEdit = 2 // 更新モード
              }
              self.$refs.dispJitsuUnsoTaiseiKanriListComponent.setJitsuUnsoTaiseiKanriHeader()
              self.$nextTick(() => {
                document.getElementById('heavy-element').style.display = ''
              })
              resolve()
            })
          },
          settingItemMethod: (kengen) => {
            console.log('settingItemMethod', kengen)
          }
        }
        console.info('call initializeForRegister', this.initializeForRegister, option)
        this.initializeForRegister(option)
      })
    },
    changeHaishaKbn: function (e) {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.tab = '#tab1'
      }
    },
    inputIraisakiEigyosho: function () {
      if (!this.viewsData.vwSagyoJisseki.eigyoshoId) { return }
      this.$set(this, 'haishaEigyoshoCd', indexeddb.getRecord(this.eigyoshoList, this.viewsData.vwSagyoJisseki.eigyoshoId).eigyoshoCd)
    },
    inputJomuinId: function () {
      if (!this.viewsData.vwKintaiJissekiJomuin.jininId) { return }

      if (!this.viewsData.vwUnkoJisseki.sharyoId) {
        const jomuinInfo = indexeddb.getRecord(this.filteredVwcMstJinin, this.viewsData.vwKintaiJissekiJomuin.jininId)
        const sharyoInfo = this.filteredMstSharyoList.find((t) => {
          return t.kaishaCd === this.currentKaishaCode && t.jomuinCd === jomuinInfo.jininCd
        })
        if (sharyoInfo) {
          this.$set(this.viewsData.vwUnkoJisseki, 'sharyoId', sharyoInfo.id)
        }
      }
      this.viewsData.vwKintaiJissekiJomuin.shuroKbn = this.getShuroKbnFirstOrder()
      this.inputAttendanceTimesElement()
    },
    inputJoshuId: function () {
      if (!this.viewsData.vwKintaiJissekiJoshu.jininId) { return }
      this.viewsData.vwKintaiJissekiJoshu.shuroKbn = this.getShuroKbnFirstOrder()
      this.inputAttendanceTimesElement()
    },
    inputAttendanceTimesElement: function () {
      var msg
      if (this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && this.viewsData.vwUnkoJisseki.jissekiKikoYmd) {
        msg = validators.compareDate(this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoYmd)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
        this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
      }
      if (this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && this.viewsData.vwUnkoJisseki.jissekiShukkoHms && this.viewsData.vwUnkoJisseki.jissekiKikoYmd && this.viewsData.vwUnkoJisseki.jissekiKikoHms) {
        msg = validators.compareDateTime(this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiShukkoHms, this.viewsData.vwUnkoJisseki.jissekiKikoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoHms)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
        this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](undefined)

        if (!this.viewsData.vwKintaiJissekiJomuin.jininId && !this.viewsData.vwKintaiJissekiJoshu.jininId) { return }
        // 出庫帰庫年月日時刻より、拘束・残業・深夜・深夜残・休憩時間を算出する。
        if (this.viewsData.vwKintaiJissekiJomuin.jininId > 0) {
          this.calculationAttendanceTimes(this.usersId, this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiShukkoHms, this.viewsData.vwUnkoJisseki.jissekiKikoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoHms, this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan ?? '')
            .then((res) => {
              const jomuinKintaiInfo = Object.assign({}, this.viewsData.vwKintaiJissekiJomuin)
              jomuinKintaiInfo.kosokuJikan = res.kosokuJikan ? (res.kosokuJikan).slice(0, 5) : null
              jomuinKintaiInfo.zangyoJikan = res.zangyoJikan ? (res.zangyoJikan).slice(0, 5) : null
              jomuinKintaiInfo.shinyaJikan = res.shinyaJikan ? (res.shinyaJikan).slice(0, 5) : null
              jomuinKintaiInfo.shinyaZangyoJikan = res.shinyaZangyoJikan ? (res.shinyaZangyoJikan).slice(0, 5) : null
              jomuinKintaiInfo.kyukeiJikan = res.kyukeiJikan ? (res.kyukeiJikan).slice(0, 5) : null
              this.viewsData.vwKintaiJissekiJomuin = Object.assign({}, jomuinKintaiInfo)
            })
        }
        if (this.viewsData.vwKintaiJissekiJoshu.jininId > 0) {
          this.calculationAttendanceTimes(this.usersId, this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiShukkoHms, this.viewsData.vwUnkoJisseki.jissekiKikoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoHms, this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan ?? '')
            .then((res) => {
              const joshuKintaiInfo = Object.assign({}, this.viewsData.vwKintaiJissekiJoshu)
              joshuKintaiInfo.kosokuJikan = res.kosokuJikan ? (res.kosokuJikan).slice(0, 5) : null
              joshuKintaiInfo.zangyoJikan = res.zangyoJikan ? (res.zangyoJikan).slice(0, 5) : null
              joshuKintaiInfo.shinyaJikan = res.shinyaJikan ? (res.shinyaJikan).slice(0, 5) : null
              joshuKintaiInfo.shinyaZangyoJikan = res.shinyaZangyoJikan ? (res.shinyaZangyoJikan).slice(0, 5) : null
              joshuKintaiInfo.kyukeiJikan = res.kyukeiJikan ? (res.kyukeiJikan).slice(0, 5) : null
              this.viewsData.vwKintaiJissekiJoshu = Object.assign({}, joshuKintaiInfo)
            })
        }
      }
    },
    calculationAttendanceTimes: function (loginId, shukkoYmd, shukkoHms, kikoYmd, kikoHms, kyukei) {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/ApiLibrary/CalculationAttendanceTimes?id=${loginId}&shukkinYmdString=${shukkoYmd}&shukkinHmsString=${shukkoHms}&taikinYmdString=${kikoYmd}&taikinHmsString=${kikoHms}&kyukeiString=${kyukei}`)
          .then((data) => {
            resolve(data.payload)
          })
      })
    },
    calcTeateKingaku: function (joshuMode) {
      let kinmuTeateKingaku1 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku1 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku1
      let kinmuTeateKingaku2 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku2 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku2
      let kinmuTeateKingaku3 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku3 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku3
      let kinmuTeateKingaku4 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku4 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku4
      let kinmuTeateKingaku5 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku5 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku5
      let kinmuTeateKingaku6 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku6 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku6
      let kinmuTeateKingaku7 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku7 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku7
      let kinmuTeateKingaku8 = joshuMode === 0 ? this.viewsData.vwKintaiJissekiJomuin.kinmuTeateKingaku8 : this.viewsData.vwKintaiJissekiJoshu.kinmuTeateKingaku8

      if (kinmuTeateKingaku1 === undefined || kinmuTeateKingaku1 === '' || kinmuTeateKingaku1 === null) { kinmuTeateKingaku1 = 0 }
      if (kinmuTeateKingaku2 === undefined || kinmuTeateKingaku2 === '' || kinmuTeateKingaku2 === null) { kinmuTeateKingaku2 = 0 }
      if (kinmuTeateKingaku3 === undefined || kinmuTeateKingaku3 === '' || kinmuTeateKingaku3 === null) { kinmuTeateKingaku3 = 0 }
      if (kinmuTeateKingaku4 === undefined || kinmuTeateKingaku4 === '' || kinmuTeateKingaku4 === null) { kinmuTeateKingaku4 = 0 }
      if (kinmuTeateKingaku5 === undefined || kinmuTeateKingaku5 === '' || kinmuTeateKingaku5 === null) { kinmuTeateKingaku5 = 0 }
      if (kinmuTeateKingaku6 === undefined || kinmuTeateKingaku6 === '' || kinmuTeateKingaku6 === null) { kinmuTeateKingaku6 = 0 }
      if (kinmuTeateKingaku7 === undefined || kinmuTeateKingaku7 === '' || kinmuTeateKingaku7 === null) { kinmuTeateKingaku7 = 0 }
      if (kinmuTeateKingaku8 === undefined || kinmuTeateKingaku8 === '' || kinmuTeateKingaku8 === null) { kinmuTeateKingaku8 = 0 }

      const kinmuTeateKingakuAmount = parseInt(kinmuTeateKingaku1, 10) + parseInt(kinmuTeateKingaku2, 10) + parseInt(kinmuTeateKingaku3, 10) + parseInt(kinmuTeateKingaku4, 10) + parseInt(kinmuTeateKingaku5, 10) + parseInt(kinmuTeateKingaku6, 10) + parseInt(kinmuTeateKingaku7, 10) + parseInt(kinmuTeateKingaku8, 10)
      if (joshuMode === 0) {
        this.$set(this, 'jomuinKinmuTeateKingakuAmount', kinmuTeateKingakuAmount)
      } else {
        this.$set(this, 'joshuKinmuTeateKingakuAmount', kinmuTeateKingakuAmount)
      }
    },
    inputOdoMater: function () {
      if (this.viewsData.vwUnkoJisseki.hatsuchiOdoMater && this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
        let hatsuchiOdoMater = this.viewsData.vwUnkoJisseki.hatsuchiOdoMater
        let chakuchiOdoMater = this.viewsData.vwUnkoJisseki.chakuchiOdoMater

        if (hatsuchiOdoMater === undefined || hatsuchiOdoMater === '' || hatsuchiOdoMater === null) { hatsuchiOdoMater = 0 }
        if (chakuchiOdoMater === undefined || chakuchiOdoMater === '' || chakuchiOdoMater === null) { chakuchiOdoMater = 0 }

        const calcSokoKyori = Math.floor(fraction.calcSubtract(chakuchiOdoMater, hatsuchiOdoMater) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'sokoKyori', calcSokoKyori)
      }
    },
    inputJissekiKyori: function () {
      let sokoKyori = this.viewsData.vwUnkoJisseki.sokoKyori
      let jisshaKyori = this.viewsData.vwUnkoJisseki.jisshaKyori
      let kushaKyori = this.viewsData.vwUnkoJisseki.kushaKyori

      if (sokoKyori === undefined || sokoKyori === '' || sokoKyori === null) { sokoKyori = 0 }
      if (jisshaKyori === undefined || jisshaKyori === '' || jisshaKyori === null) { jisshaKyori = 0 }
      if (kushaKyori === undefined || kushaKyori === '' || kushaKyori === null) { kushaKyori = 0 }

      let calcKyori = 0

      if (!this.viewsData.vwUnkoJisseki.jisshaKyori && this.viewsData.vwUnkoJisseki.sokoKyori && this.viewsData.vwUnkoJisseki.kushaKyori) {
        calcKyori = Math.floor(fraction.calcSubtract(sokoKyori, kushaKyori) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'jisshaKyori', calcKyori)
      } else if (!this.viewsData.vwUnkoJisseki.kushaKyori && this.viewsData.vwUnkoJisseki.sokoKyori && this.viewsData.vwUnkoJisseki.jisshaKyori) {
        calcKyori = Math.floor(fraction.calcSubtract(sokoKyori, jisshaKyori) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'kushaKyori', calcKyori)
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.recHaisoMeisai.taikiJikan
      let taikiJikanTanka = this.recHaisoMeisai.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.recHaisoMeisai, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    calcJikanWarimashiKingaku: function () {
      let warimashiTaishoJikan = this.recHaisoMeisai.warimashiTaishoJikan
      let warimashiJikanTanka = this.recHaisoMeisai.warimashiJikanTanka

      if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '' || warimashiTaishoJikan === null) { warimashiTaishoJikan = '00:00' }
      if (warimashiJikanTanka === undefined || warimashiJikanTanka === '' || warimashiJikanTanka === null) { warimashiJikanTanka = 0 }

      warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)

      const jikanWarimashiKingaku = this.calcFraction((warimashiTaishoJikan / 60) * warimashiJikanTanka)
      this.$set(this.recHaisoMeisai, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
    },
    calcKyoriWarimashiKingaku: function () {
      let warimashiTaishoKyori = this.recHaisoMeisai.warimashiTaishoKyori
      let warimashiKyoriTanka = this.recHaisoMeisai.warimashiKyoriTanka

      if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '' || warimashiTaishoKyori === null) { warimashiTaishoKyori = 0 }
      if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '' || warimashiKyoriTanka === null) { warimashiKyoriTanka = 0 }

      const kyoriWarimashiKingaku = this.calcFraction(warimashiTaishoKyori * warimashiKyoriTanka)
      this.$set(this.recHaisoMeisai, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
    },
    calcNenryoKingaku: function () {
      let suryo = this.recNenryo.suryo
      let keihiTanka = this.recNenryo.keihiTanka

      if (suryo === undefined || suryo === '' || suryo === null) { suryo = 0 }
      if (keihiTanka === undefined || keihiTanka === '' || keihiTanka === null) { keihiTanka = 0 }

      const nenryoKingaku = this.calcFraction(suryo * keihiTanka)
      this.$set(this.recNenryo, 'keihiKingaku', nenryoKingaku)
    },
    calcFraction: function (x) {
      if ([undefined, null, ''].includes(this.recTokuisakiInfo) || [undefined, null, ''].includes(this.recTokuisakiInfo.unchinHasuKeisanKbn)) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    },
    // ----------------------------------------------------------------------------------------------------
    // 前回帰庫時オドメーター取得
    // ----------------------------------------------------------------------------------------------------
    // 車両IDが入力されたら、最終運行実績情報取得メソッドを呼ぶ
    changeCarInfo: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn !== '03') {
        if ([undefined, null, ''].includes(this.viewsData.vwUnkoJisseki.sharyoId)) {
          this.jishaSharyoSbt = null
          return
        }
        console.log('changeTokuisakiId')
        this.jishaSharyoSbt = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId).shashuSbt
        // this.$set(this.viewsData.vwUnkoJisseki, 'jishaSharyoSbt', carShashuSbt)
        if (!this.viewsData.vwKintaiJissekiJomuin.jininId) {
          const sharyoInfo = indexeddb.getRecord(this.filteredMstSharyoList, this.viewsData.vwUnkoJisseki.sharyoId)

          const jomuinInfo = indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredVwcMstJinin, 'jininCd', sharyoInfo.jomuinCd, this.baseYmd)

          if (jomuinInfo) {
            this.$set(this.viewsData.vwKintaiJissekiJomuin, 'jininId', jomuinInfo.id)
          }
        }
        this.getLastUnkoJissekiInfo(
          this.viewsData.vwUnkoJisseki.sharyoId,
          this.viewsData.vwUnkoJisseki.jissekiShukkoYmd ? this.viewsData.vwUnkoJisseki.jissekiShukkoYmd : this.viewsData.vwUnkoJisseki.unkoYmd,
          this.viewsData.vwUnkoJisseki.jissekiShukkoHms,
          0)
          .then((lastUnkoInfo) => {
            if (lastUnkoInfo) {
              if (lastUnkoInfo.chakuchiOdoMater && !this.viewsData.vwUnkoJisseki.hatsuchiOdoMater) {
                this.$set(this.viewsData.vwUnkoJisseki, 'hatsuchiOdoMater', lastUnkoInfo.chakuchiOdoMater)
              }
            }
          })
        this.getLastUnkoJissekiInfo(
          this.viewsData.vwUnkoJisseki.sharyoId,
          this.viewsData.vwUnkoJisseki.jissekiKikoYmd ? this.viewsData.vwUnkoJisseki.jissekiKikoYmd : this.viewsData.vwUnkoJisseki.unkoYmd,
          this.viewsData.vwUnkoJisseki.jissekiKikoHms,
          1)
          .then((lastUnkoInfo) => {
            if (lastUnkoInfo) {
              if (lastUnkoInfo.hatsuchiOdoMater && !this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
                this.$set(this.viewsData.vwUnkoJisseki, 'chakuchiOdoMater', lastUnkoInfo.hatsuchiOdoMater)
              }
            }
          })
      } else {
        if (!this.viewsData.vwUnkoJisseki.sharyoId) { return }
        this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId).shashuSbt
        this.setYoshaInfo()
      }
      if (this.custoMizeChangeCarInfo) { this.custoMizeChangeCarInfo() }
    },
    onGetLastJissekiOdoMater: function () {
      if (!this.viewsData.vwUnkoJisseki.sharyoId) { return }
      this.getLastUnkoJissekiInfo(
        this.viewsData.vwUnkoJisseki.sharyoId,
        this.viewsData.vwUnkoJisseki.jissekiShukkoYmd ? this.viewsData.vwUnkoJisseki.jissekiShukkoYmd : this.viewsData.vwUnkoJisseki.unkoYmd,
        this.viewsData.vwUnkoJisseki.jissekiShukkoHms,
        0)
        .then((lastUnkoInfo) => {
          if (lastUnkoInfo) {
            this.$set(this.viewsData.vwUnkoJisseki, 'hatsuchiOdoMater', lastUnkoInfo.chakuchiOdoMater)
          }
        })
      this.getLastUnkoJissekiInfo(
        this.viewsData.vwUnkoJisseki.sharyoId,
        this.viewsData.vwUnkoJisseki.jissekiKikoYmd ? this.viewsData.vwUnkoJisseki.jissekiKikoYmd : this.viewsData.vwUnkoJisseki.unkoYmd,
        this.viewsData.vwUnkoJisseki.jissekiKikoHms,
        1)
        .then((lastUnkoInfo) => {
          if (lastUnkoInfo) {
            this.$set(this.viewsData.vwUnkoJisseki, 'chakuchiOdoMater', lastUnkoInfo.hatsuchiOdoMater)
          }
        })
      this.inputOdoMater()
    },
    getLastUnkoJissekiInfo: function (sharyoId, targetYmd, targetHms, searchMode) {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2PRMD0020/LastUnkoJissekiInfoFind?id=${sharyoId}&targetYmdString=${targetYmd}&targetHms=${targetHms}&searchMode=${searchMode}`)
          .then((data) => {
            resolve(data.payload)
          })
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 得意先IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeTokuisaki: function () {
      if (!this.recHaisoMeisai.tokuisakiId) {
        this.recHaisoMeisai.torihikisakiCd = null
        return
      }
      console.log('changeTokuisakiId')
      const tokuisakiInfo = indexeddb.getRecord(this.torihikisakiList, this.recHaisoMeisai.tokuisakiId)
      this.recHaisoMeisai.torihikisakiCd = tokuisakiInfo ? tokuisakiInfo.torihikisakiCd : ''
      if (this.recHaisoMeisai.motoukeFlg) {
        this.$set(this.recHaisoMeisai, 'maninushiNm', tokuisakiInfo ? tokuisakiInfo.torihikisakiNm : '')
        if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
          this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputManinushiNm()
        }
      }
      this.getTokuisakiInfo(this.recHaisoMeisai.tokuisakiId)
    },
    getTokuisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2PRMD0020/TokuisakiInfoFind?id=${this.recHaisoMeisai.tokuisakiId}`)
          .then((data) => {
            this.recTokuisakiInfo = data.payload
            console.log('getTokuisakiInfo', this.recTokuisakiInfo)
            this.initSeikyuYoteiYmd()
            if (!this.recHaisoMeisai.unchinKeisanKbn && this.recTokuisakiInfo.unchinKeisanKbn) {
              this.$set(this.recHaisoMeisai, 'unchinKeisanKbn', this.recTokuisakiInfo.unchinKeisanKbn)
            }
            this.recHaisoMeisai.warimashiJikanTanka = this.recHaisoMeisai.warimashiJikanTanka ? this.recHaisoMeisai.warimashiJikanTanka : this.recTokuisakiInfo.warimashiJikanTanka
            this.recHaisoMeisai.warimashiKyoriTanka = this.recHaisoMeisai.warimashiKyoriTanka ? this.recHaisoMeisai.warimashiKyoriTanka : this.recTokuisakiInfo.warimashiKyoriTanka
            this.calcJikanWarimashiKingaku()
            this.calcKyoriWarimashiKingaku()
          })
        resolve()
      })
    },
    initSeikyuYoteiYmd: function () {
      if (this.initializeMode && this.viewsData.vwHaisoMeisai.length > 0) {
        this.initializeMode = false
        return
      }
      const keijobiKbn = this.recTokuisakiInfo.keijobiKbn

      if (keijobiKbn === undefined || keijobiKbn === '') {
        this.seikyuYoteiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
        return
      }
      /*
      if (this.recHaisoMeisai.seikyuYoteiYmd !== filter.dateFormatter(new Date()) && !this.recHaisoMeisai.meisaiOrder) { return }

      if (this.recHaisoMeisai.seikyuYoteiYmd && this.recHaisoMeisai.meisaiOrder) { return }
      */
      if (keijobiKbn === '1' && this.recHaisoMeisai.hatsuchiYmd !== null && this.recHaisoMeisai.hatsuchiYmd !== '' && this.recHaisoMeisai.hatsuchiYmd !== undefined) {
        this.seikyuYoteiYmd = this.recHaisoMeisai.hatsuchiYmd
      } else if (keijobiKbn === '2' && this.recHaisoMeisai.chakuchiYmd !== null && this.recHaisoMeisai.chakuchiYmd !== '' && this.recHaisoMeisai.chakuchiYmd !== undefined) {
        this.seikyuYoteiYmd = this.recHaisoMeisai.chakuchiYmd
      } else {
        this.seikyuYoteiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      }
    },
    // 反映ボタン押下時
    teikeiCourseNoSync: function () {
      if (!this.recHaisoMeisai.teikeiKihonNo) { return }
      var teikeiInfo = this.getTeikeiInfo(this.recHaisoMeisai.teikeiKihonNo)
      this.teikeiCourseNoDialogSync(teikeiInfo)
    },
    // ポップアップから選択時
    teikeiCourseNoDialogSync: function (elem) {
      let initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: elem.teikeiKihonNo,
        // juchuEigyoshoId: elem.tantoEigyoshoId,
        ohfukuSbt: elem.ohfukuSbt,
        chumonNo: elem.chumonNo,
        tokuisakiId: elem.tokuisakiId,
        mstHinmeiId: elem.mstHinmeiId,
        hinmeiBiko: elem.hinmeiBiko,
        hatsuchiId: elem.hatsuchiId,
        hatsuchiBiko: elem.hatsuchiBiko,
        hatsuchiHms: elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : null,
        hatsuchiHmsBiko: elem.hatsuchiHmsBiko,
        keiyuchiId1: elem.keiyuchiId1,
        keiyuchiBiko1: elem.keiyuchiId1Biko,
        keiyuchiId2: elem.keiyuchiId2,
        keiyuchiBiko2: elem.keiyuchiId2Biko,
        keiyuchiId3: elem.keiyuchiId3,
        keiyuchiBiko3: elem.keiyuchiId3Biko,
        keiyuchiId4: elem.keiyuchiId4,
        keiyuchiBiko4: elem.keiyuchiId4Biko,
        keiyuchiId5: elem.keiyuchiId5,
        keiyuchiBiko5: elem.keiyuchiId5Biko,
        chakuchiId: elem.chakuchiId,
        chakuchiBiko: elem.chakuchiBiko,
        chakuchiHms: elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : null,
        chakuchiHmsBiko: elem.chakuchiHmsBiko,
        unchinKeisanKbn: elem.unchinKeisanKbn,
        seikyuShashuSbt: elem.seikyuShashuSbt,
        yoteiSokoKyori: d2fmt.removeComma(elem.yoteiSokoKyori),
        yoteiSagyoJikan: elem.yoteiSagyoJikanDisp,
        juchuSuryo: d2fmt.removeComma(elem.juchuSuryo),
        unitKbn: elem.unitKbn,
        juchuJuryo: d2fmt.removeComma(elem.juchuJuryo),
        tanka: d2fmt.removeComma(elem.tanka),
        hiwayPrice: d2fmt.removeComma(elem.hiwayPrice),
        unchinHokaKingaku: d2fmt.removeComma(elem.unchinHokaKingaku),
        hokanKingaku: d2fmt.removeComma(elem.hokanKingaku),
        niekiKingaku: d2fmt.removeComma(elem.niekiKingaku),
        unchinHokaHikazei: d2fmt.removeComma(elem.unchinHokaHikazei),
        nenryoSurcharge: d2fmt.removeComma(elem.nenryoSurcharge),
        tsumikomiKingaku: d2fmt.removeComma(elem.tsumikomiKingaku),
        torioroshiKingaku: d2fmt.removeComma(elem.torioroshiKingaku),
        taikiJikan: elem.taikiJikanDisp,
        taikiJikanTanka: d2fmt.removeComma(elem.taikiJikanTanka),
        taikiJikanKingaku: d2fmt.removeComma(elem.taikiJikanKingaku),
        futaiGyomuKingaku: d2fmt.removeComma(elem.futaiGyomuKingaku),
        futaiGyomuKingaku1: d2fmt.removeComma(elem.futaiGyomuKingaku1),
        futaiGyomuKingaku2: d2fmt.removeComma(elem.futaiGyomuKingaku2),
        futaiGyomuKingaku3: d2fmt.removeComma(elem.futaiGyomuKingaku3),
        futaiGyomuKingaku4: d2fmt.removeComma(elem.futaiGyomuKingaku4),
        futaiGyomuKingaku5: d2fmt.removeComma(elem.futaiGyomuKingaku5),
        futaiGyomuKingaku6: d2fmt.removeComma(elem.futaiGyomuKingaku6),
        futaiGyomuKingaku7: d2fmt.removeComma(elem.futaiGyomuKingaku7),
        futaiGyomuKingaku8: d2fmt.removeComma(elem.futaiGyomuKingaku8),
        futaiGyomuKingaku9: d2fmt.removeComma(elem.futaiGyomuKingaku9),
        futaiGyomuKingaku10: d2fmt.removeComma(elem.futaiGyomuKingaku10),
        tatekaekinHikazei: d2fmt.removeComma(elem.tatekaekinHikazei),
        warimashiTaishoJikan: elem.warimashiTaishoJikanDisp,
        warimashiJikanTanka: d2fmt.removeComma(elem.warimashiJikanTanka),
        warimashiTaishoKyori: d2fmt.removeComma(elem.warimashiTaishoKyori),
        warimashiKyoriTanka: d2fmt.removeComma(elem.warimashiKyoriTanka),
        warimashiSonotaKingsku: d2fmt.removeComma(elem.warimashiSonotaKingaku),
        yoshaKihonUnchin: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchin) : null,
        yoshaHiwayPrice: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaHiwayPrice) : null,
        sagyoinTeateKingaku1: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? d2fmt.removeComma(elem.sagyoinTeateKingaku1) : null,
        sharyoKeihiHiwayEtc: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? d2fmt.removeComma(elem.sharyoKeihiHiwayEtc) : null,
        sharyoKeihiHiwayGenkin: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? d2fmt.removeComma(elem.sharyoKeihiHiwayGenkin) : null,
        sharyoKeihiFerry: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? d2fmt.removeComma(elem.sharyoKeihiFerry) : null,
        seikyuBiko: elem.seikyuBiko,
        renrakuBiko: elem.renrakuBiko
      }
      this.setInitHaisoMeisai(initHaisoMeisai)
      initHaisoMeisai = undefined
    },
    selectJuchuHimozukeInfo: function (e) {
      this.selectJuchuRirekiInfo(e, 'himozuke')
    },
    selectJuchuRirekiInfo: function (e, m) {
      console.log(e)
      if (!e) { return }
      let initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: e.teikeiKihonNo,
        ohfukuSbt: e.ohfukuSbt,
        chumonNo: e.chumonNo,
        tokuisakiId: e.tokuisakiId,
        mstHinmeiId: e.mstHinmeiId,
        hinmeiBiko: e.hinmeiBiko,
        hatsuchiId: e.hatsuchiId,
        hatsuchiBiko: e.hatsuchiBiko,
        hatsuchiHms: e.hatsuchiHms ? e.hatsuchiHmsDisp : null,
        hatsuchiHmsBiko: e.hatsuchiHmsBiko,
        keiyuchiId1: e.keiyuchiId1,
        keiyuchiBiko1: e.keiyuchiBiko1,
        keiyuchiId2: e.keiyuchiId2,
        keiyuchiBiko2: e.keiyuchiBiko2,
        keiyuchiId3: e.keiyuchiId3,
        keiyuchiBiko3: e.keiyuchiBiko3,
        keiyuchiId4: e.keiyuchiId4,
        keiyuchiBiko4: e.keiyuchiBiko4,
        keiyuchiId5: e.keiyuchiId5,
        keiyuchiBiko5: e.keiyuchiBiko5,
        chakuchiId: e.chakuchiId,
        chakuchiBiko: e.chakuchiBiko,
        chakuchiHms: e.chakuchiHms ? e.chakuchiHmsDisp : null,
        chakuchiHmsBiko: e.chakuchiHmsBiko,
        unchinKeisanKbn: e.unchinKeisanKbn,
        seikyuShashuSbt: e.seikyuShashuSbt,
        yoteiSokoKyori: e.yoteiSokoKyori,
        yoteiSagyoJikan: e.yoteiSagyoJikanDisp,
        juchuSuryo: e.juchuSuryo,
        unitKbn: e.unitKbn,
        juchuJuryo: e.juchuJuryo,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        unchinHokaKingaku: e.unchinHokaKingaku,
        hokanKingaku: e.hokanKingaku,
        niekiKingaku: e.niekiKingaku,
        unchinHokaHikazei: e.unchinHokaHikazei,
        nenryoSurcharge: e.nenryoSurcharge,
        tsumikomiKingaku: e.tsumikomiKingaku,
        torioroshiKingaku: e.torioroshiKingaku,
        taikiJikan: e.taikiJikanDisp,
        taikiJikanTanka: e.taikiJikanTanka,
        taikiJikanKingaku: e.taikiJikanKingaku,
        futaiGyomuKingaku: e.futaiGyomuKingaku,
        futaiGyomuKingaku1: e.futaiGyomuKingaku1,
        futaiGyomuKingaku2: e.futaiGyomuKingaku2,
        futaiGyomuKingaku3: e.futaiGyomuKingaku3,
        futaiGyomuKingaku4: e.futaiGyomuKingaku4,
        futaiGyomuKingaku5: e.futaiGyomuKingaku5,
        futaiGyomuKingaku6: e.futaiGyomuKingaku6,
        futaiGyomuKingaku7: e.futaiGyomuKingaku7,
        futaiGyomuKingaku8: e.futaiGyomuKingaku8,
        futaiGyomuKingaku9: e.futaiGyomuKingaku9,
        futaiGyomuKingaku10: e.futaiGyomuKingaku10,
        tatekaekinHikazei: e.tatekaekinHikazei,
        warimashiTaishoJikan: e.warimashiTaishoJikanDisp,
        warimashiJikanTanka: e.warimashiJikanTanka,
        warimashiTaishoKyori: e.warimashiTaishoKyori,
        warimashiKyoriTanka: e.warimashiKyoriTanka,
        warimashiSonotaKingsku: e.warimashiSonotaKingsku,
        yoshaKihonUnchin: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaKihonUnchin : null,
        yoshaHiwayPrice: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaHiwayPrice : null,
        sagyoinTeateKingaku1: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? e.sagyoinTeateKingaku1 : null,
        sharyoKeihiHiwayEtc: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? e.sharyoKeihiHiwayEtc : null,
        sharyoKeihiHiwayGenkin: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? e.sharyoKeihiHiwayGenkin : null,
        sharyoKeihiFerry: this.viewsData.vwUnkoJisseki.haishaKbn !== '03' ? e.sharyoKeihiFerry : null,
        seikyuBiko: e.seikyuBiko,
        renrakuBiko: e.renrakuBiko
      }

      if (m === 'himozuke') {
        initHaisoMeisai.id = e.id
        initHaisoMeisai.tjmId = e.tjmId
        initHaisoMeisai.tjhId = e.tjhId
        initHaisoMeisai.tjkKinId = e.tjkKinId
        initHaisoMeisai.tjmKinId = e.tjmKinId
        initHaisoMeisai.tjhKinId = e.tjhKinId
        initHaisoMeisai.tjrKihonId = e.tjrKihonId
        initHaisoMeisai.tjrMeisaiId = e.tjrMeisaiId
        initHaisoMeisai.tsmId = e.tsmId
        initHaisoMeisai.tskId = e.tskId
        initHaisoMeisai.tskHinmokuId = e.tskHinmokuId
        initHaisoMeisai.tskMeisaiId = e.tskMeisaiId
        initHaisoMeisai.thkId = e.thkId
        initHaisoMeisai.thmId = e.thmId
        initHaisoMeisai.tshId = e.tshId
        initHaisoMeisai.thkKinId = e.thkKinId
        initHaisoMeisai.thmKinId = e.thmKinId
        initHaisoMeisai.thhId = e.thhId
        initHaisoMeisai.thhKinId = e.thhKinId
        initHaisoMeisai.tjkUpdDate = e.tjkUpdDate
        initHaisoMeisai.tjmUpdDate = e.tjmUpdDate
        initHaisoMeisai.tjhUpdDate = e.tjhUpdDate
        initHaisoMeisai.tjkKinUpdDate = e.tjkKinUpdDate
        initHaisoMeisai.tjmKinUpdDate = e.tjmKinUpdDate
        initHaisoMeisai.tjhKinUpdDate = e.tjhKinUpdDate
        initHaisoMeisai.tjrKihonUpdDate = e.tjrKihonUpdDate
        initHaisoMeisai.tjrMeisaiUpdDate = e.tjrMeisaiUpdDate
        initHaisoMeisai.tsmUpdDate = e.tsmUpdDate
        initHaisoMeisai.tskMeisaiUpdDate = e.tskMeisaiUpdDate
        initHaisoMeisai.tshUpdDate = e.tshUpdDate
        initHaisoMeisai.tskHinmokuUpdDate = e.tskHinmokuUpdDate
        initHaisoMeisai.thkUpdDate = e.thkUpdDate
        initHaisoMeisai.thmUpdDate = e.thmUpdDate
        initHaisoMeisai.thkKinUpdDate = e.thkKinUpdDate
        initHaisoMeisai.thmKinUpdDate = e.thmKinUpdDate
        initHaisoMeisai.thhUpdDate = e.thhUpdDate
        initHaisoMeisai.thhKinUpdDate = e.thhKinUpdDate
        initHaisoMeisai.juchuYmd = e.juchuYmd
        initHaisoMeisai.juchuNo = e.juchuNo
        initHaisoMeisai.sagyoYoteiYmd = e.sagyoYoteiYmd
        initHaisoMeisai.seikyuZumiFlg = e.seikyuZumiFlg ?? false
        initHaisoMeisai.shiharaiZumiFlg = e.shiharaiZumiFlg ?? false
        initHaisoMeisai.motoukeFlg = e.motoukeFlg
        initHaisoMeisai.maninushiNm = e.maninushiNm
        initHaisoMeisai.chumonshoReceiveZumiFlg = e.chumonshoReceiveZumiFlg
        initHaisoMeisai.chumonshoReceiveSbt = e.chumonshoReceiveSbt
        initHaisoMeisai.chumonshoReceiveBiko = e.chumonshoReceiveBiko
        initHaisoMeisai.chumonkakuninshoSendZumiFlg = e.chumonkakuninshoSendZumiFlg
        initHaisoMeisai.hacchushoSendZumiFlg = e.hacchushoSendZumiFlg
        initHaisoMeisai.motoukeNm = e.motoukeNm
        initHaisoMeisai.juchuUkeoiKaiso = e.juchuUkeoiKaiso
        initHaisoMeisai.motoukeRenrakuSbt = e.motoukeRenrakuSbt
        initHaisoMeisai.motoukeRenrakuBiko = e.motoukeRenrakuBiko
        initHaisoMeisai.motoukeRenrakusaki = e.motoukeRenrakusaki
        initHaisoMeisai.chumonshoReceiveZumiFlg = e.chumonshoReceiveZumiFlg
        initHaisoMeisai.chumonshoReceiveSbt = e.chumonshoReceiveSbt
        initHaisoMeisai.chumonshoReceiveBiko = e.chumonshoReceiveBiko
        initHaisoMeisai.motoukeHokokuZumiFlg = e.motoukeHokokuZumiFlg
        initHaisoMeisai.motoukeHokokuYmd = e.motoukeHokokuYmd
        initHaisoMeisai.jitsuUnsoHokokuMemo = e.jitsuUnsoHokokuMemo
        initHaisoMeisai.isHasEasyEditSeikyuKingaku = false
        initHaisoMeisai.isHasEasyEditShiharaiKingaku = false
      }

      this.setInitHaisoMeisai(initHaisoMeisai)
      initHaisoMeisai = undefined
    },
    setInitHaisoMeisai: function (e) {
      this.hinmeiSwitch = Boolean(!e.mstHinmeiId && e.hinmeiBiko)
      this.hatsuchiSwitch = Boolean(!e.hatsuchiId && e.hatsuchiBiko)
      this.hatsuchiHmsSwitch = Boolean(!e.hatsuchiHms && e.hatsuchiHmsBiko)
      this.chakuchiSwitch = Boolean(!e.chakuchiId && e.chakuchiBiko)
      this.chakuchiHmsSwitch = Boolean(!e.chakuchiHms && e.chakuchiHmsBiko)
      this.expandKeiyuchi = Boolean(e.keiyuchiId2 || e.keiyuchiBiko2 || e.keiyuchiId3 || e.keiyuchiBiko3 || e.keiyuchiId4 || e.keiyuchiBiko4 || e.keiyuchiId5 || e.keiyuchiBiko5)

      if (e.hatsuchiYmd && e.hatsuchiHms && e.chakuchiHms && (e.hatsuchiYmd >= e.chakuchiYmd || !e.chakuchiYmd) && e.hatsuchiHms > e.chakuchiHms) {
        e.chakuchiYmd = filter.dateFormatter(dayjs(e.hatsuchiYmd).add(1, 'd'))
      }
      this.recHaisoMeisai = Object.assign({}, e)
      this.calcJikanWarimashiKingaku()
      this.calcKyoriWarimashiKingaku()
    },
    onRowDoubleClick: function (e, f) {
      if (f.item.delFlg) { return }
      this.onMeisaiEditOpenButtonClick(f.item)
    },
    onMeisaiNewButtonClick: function () {
      if (this.activeTab === '01') {
        this.initHaisoMeisai()
      } else if (this.activeTab === '02') {
        this.initNenryo()
      } else if (this.activeTab === '03') {
        this.initTsukoryo()
      }
    },
    onMeisaiEditMoveUpButtonClick: function (item) {
      if (this.activeTab === '01') {
        const index = this.viewsData.vwHaisoMeisai.indexOf(item)
        if (index === 0 || index === -1) { return }
        this.viewsData.vwHaisoMeisai.splice(
          index - 1,
          2,
          this.viewsData.vwHaisoMeisai[index],
          this.viewsData.vwHaisoMeisai[index - 1])
        if (this.haisoMeisaiEditIndex === index) {
          this.haisoMeisaiEditIndex = index - 1
          this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index - 1].meisaiOrder
        } else if (this.haisoMeisaiEditIndex === index - 1) {
          this.haisoMeisaiEditIndex = index
          this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index].meisaiOrder
        }
        const tempJuchuMeisai1 = this.viewsData.vwHaisoMeisai[index]
        const tempJuchuMeisai2 = this.viewsData.vwHaisoMeisai[index - 1]
        const tempmeisaiOrder1 = this.viewsData.vwHaisoMeisai[index - 1].meisaiOrder
        this.viewsData.vwHaisoMeisai[index - 1] = tempJuchuMeisai2
        this.viewsData.vwHaisoMeisai[index - 1].meisaiOrder = tempJuchuMeisai1.meisaiOrder
        this.viewsData.vwHaisoMeisai[index] = tempJuchuMeisai1
        this.viewsData.vwHaisoMeisai[index].meisaiOrder = tempmeisaiOrder1
      } else if (this.activeTab === '02') {
        const index = this.viewsData.vwSharyoKeihiNenryohi.indexOf(item)
        if (index === 0 || index === -1) { return }
        this.viewsData.vwSharyoKeihiNenryohi.splice(
          index - 1,
          2,
          this.viewsData.vwSharyoKeihiNenryohi[index],
          this.viewsData.vwSharyoKeihiNenryohi[index - 1])
        if (this.nenryoEditIndex === index) {
          this.nenryoEditIndex = index - 1
          this.recNenryo.tekiyo5 = this.viewsData.vwSharyoKeihiNenryohi[index - 1].tekiyo5
        } else if (this.nenryoEditIndex === index - 1) {
          this.nenryoEditIndex = index
          this.recNenryo.tekiyo5 = this.viewsData.vwSharyoKeihiNenryohi[index].tekiyo5
        }
        const tempSharyoKeihiNenryohi1 = this.viewsData.vwSharyoKeihiNenryohi[index]
        const tempSharyoKeihiNenryohi2 = this.viewsData.vwSharyoKeihiNenryohi[index - 1]
        const tempNenryohiNo1 = this.viewsData.vwSharyoKeihiNenryohi[index - 1].tekiyo5
        this.viewsData.vwSharyoKeihiNenryohi[index - 1] = tempSharyoKeihiNenryohi2
        this.viewsData.vwSharyoKeihiNenryohi[index - 1].tekiyo5 = tempSharyoKeihiNenryohi1.tekiyo5
        this.viewsData.vwSharyoKeihiNenryohi[index] = tempSharyoKeihiNenryohi1
        this.viewsData.vwSharyoKeihiNenryohi[index].tekiyo5 = tempNenryohiNo1
      } else if (this.activeTab === '03') {
        const index = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(item)
        if (index === 0 || index === -1) { return }
        this.viewsData.vwSharyoKeihiTsukoryo.splice(
          index - 1,
          2,
          this.viewsData.vwSharyoKeihiTsukoryo[index],
          this.viewsData.vwSharyoKeihiTsukoryo[index - 1])
        if (this.tsukoryoEditIndex === index) {
          this.tsukoryoEditIndex = index - 1
          this.recTsukoryo.tekiyo5 = this.viewsData.vwSharyoKeihiTsukoryo[index - 1].tekiyo5
        } else if (this.tsukoryoEditIndex === index - 1) {
          this.tsukoryoEditIndex = index
          this.recTsukoryo.tekiyo5 = this.viewsData.vwSharyoKeihiTsukoryo[index].tekiyo5
        }
        const tempSharyoKeihiTsukoryo1 = this.viewsData.vwSharyoKeihiTsukoryo[index]
        const tempSharyoKeihiTsukoryo2 = this.viewsData.vwSharyoKeihiTsukoryo[index - 1]
        const tempTsukoryoNo1 = this.viewsData.vwSharyoKeihiTsukoryo[index - 1].tekiyo5
        this.viewsData.vwSharyoKeihiTsukoryo[index - 1] = tempSharyoKeihiTsukoryo2
        this.viewsData.vwSharyoKeihiTsukoryo[index - 1].tekiyo5 = tempSharyoKeihiTsukoryo1.tekiyo5
        this.viewsData.vwSharyoKeihiTsukoryo[index] = tempSharyoKeihiTsukoryo1
        this.viewsData.vwSharyoKeihiTsukoryo[index].tekiyo5 = tempTsukoryoNo1
      }
      this.dispSelectedItem()
    },
    onMeisaiEditMoveDownButtonClick: function (item) {
      if (this.activeTab === '01') {
        const index = this.viewsData.vwHaisoMeisai.indexOf(item)
        if (index === this.viewsData.vwHaisoMeisai.length - 1 || index === -1) { return }
        this.viewsData.vwHaisoMeisai.splice(
          index,
          2,
          this.viewsData.vwHaisoMeisai[index + 1],
          this.viewsData.vwHaisoMeisai[index])
        if (this.haisoMeisaiEditIndex === index) {
          this.haisoMeisaiEditIndex = index + 1
          this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index + 1].meisaiOrder
        } else if (this.haisoMeisaiEditIndex === index + 1) {
          this.haisoMeisaiEditIndex = index
          this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index].meisaiOrder
        }
        const tempJuchuMeisai1 = this.viewsData.vwHaisoMeisai[index]
        const tempJuchuMeisai2 = this.viewsData.vwHaisoMeisai[index + 1]
        const tempmeisaiOrder1 = this.viewsData.vwHaisoMeisai[index].meisaiOrder
        this.viewsData.vwHaisoMeisai[index] = tempJuchuMeisai1
        this.viewsData.vwHaisoMeisai[index].meisaiOrder = tempJuchuMeisai2.meisaiOrder
        this.viewsData.vwHaisoMeisai[index + 1] = tempJuchuMeisai2
        this.viewsData.vwHaisoMeisai[index + 1].meisaiOrder = tempmeisaiOrder1
      } else if (this.activeTab === '02') {
        const index = this.viewsData.vwSharyoKeihiNenryohi.indexOf(item)
        if (index === this.viewsData.vwSharyoKeihiNenryohi.length - 1 || index === -1) { return }
        this.viewsData.vwSharyoKeihiNenryohi.splice(
          index,
          2,
          this.viewsData.vwSharyoKeihiNenryohi[index + 1],
          this.viewsData.vwSharyoKeihiNenryohi[index])
        if (this.nenryoEditIndex === index) {
          this.nenryoEditIndex = index + 1
          this.recNenryo.tekiyo5 = this.viewsData.vwSharyoKeihiNenryohi[index + 1].tekiyo5
        } else if (this.nenryoEditIndex === index + 1) {
          this.nenryoEditIndex = index
          this.recNenryo.tekiyo5 = this.viewsData.vwSharyoKeihiNenryohi[index].tekiyo5
        }
        const tempSharyoKeihiNenryohi1 = this.viewsData.vwSharyoKeihiNenryohi[index]
        const tempSharyoKeihiNenryohi2 = this.viewsData.vwSharyoKeihiNenryohi[index + 1]
        const tempNenryohiNo1 = this.viewsData.vwSharyoKeihiNenryohi[index].tekiyo5
        this.viewsData.vwSharyoKeihiNenryohi[index] = tempSharyoKeihiNenryohi1
        this.viewsData.vwSharyoKeihiNenryohi[index].tekiyo5 = tempSharyoKeihiNenryohi2.tekiyo5
        this.viewsData.vwSharyoKeihiNenryohi[index + 1] = tempSharyoKeihiNenryohi2
        this.viewsData.vwSharyoKeihiNenryohi[index + 1].tekiyo5 = tempNenryohiNo1
      } else if (this.activeTab === '03') {
        const index = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(item)
        if (index === this.viewsData.vwSharyoKeihiTsukoryo.length - 1 || index === -1) { return }
        this.viewsData.vwSharyoKeihiTsukoryo.splice(
          index,
          2,
          this.viewsData.vwSharyoKeihiTsukoryo[index + 1],
          this.viewsData.vwSharyoKeihiTsukoryo[index])
        if (this.tsukoryoEditIndex === index) {
          this.tsukoryoEditIndex = index + 1
          this.recTsukoryo.tekiyo5 = this.viewsData.vwSharyoKeihiTsukoryo[index + 1].tekiyo5
        } else if (this.tsukoryoEditIndex === index + 1) {
          this.tsukoryoEditIndex = index
          this.recTsukoryo.tekiyo5 = this.viewsData.vwSharyoKeihiTsukoryo[index].tekiyo5
        }
        const tempSharyoKeihiTsukoryo1 = this.viewsData.vwSharyoKeihiTsukoryo[index]
        const tempSharyoKeihiTsukoryo2 = this.viewsData.vwSharyoKeihiTsukoryo[index + 1]
        const tempTsukoryoNo1 = this.viewsData.vwSharyoKeihiTsukoryo[index].tekiyo5
        this.viewsData.vwSharyoKeihiTsukoryo[index] = tempSharyoKeihiTsukoryo1
        this.viewsData.vwSharyoKeihiTsukoryo[index].tekiyo5 = tempSharyoKeihiTsukoryo2.tekiyo5
        this.viewsData.vwSharyoKeihiTsukoryo[index + 1] = tempSharyoKeihiTsukoryo2
        this.viewsData.vwSharyoKeihiTsukoryo[index + 1].tekiyo5 = tempTsukoryoNo1
      }
      this.dispSelectedItem()
    },
    dispSelectedItem: function () {
      let selectedItem = {}
      if (this.activeTab === '01') {
        selectedItem = this.viewsData.vwHaisoMeisai.find((t) => {
          return t.selectRow === true
        })
      } else if (this.activeTab === '02') {
        selectedItem = this.viewsData.vwSharyoKeihiNenryohi.find((t) => {
          return t.selectRow === true
        })
      } else if (this.activeTab === '03') {
        selectedItem = this.viewsData.vwSharyoKeihiTsukoryo.find((t) => {
          return t.selectRow === true
        })
      }
      this.onMeisaiEditOpenButtonClick(selectedItem)
    },
    onMeisaiEditOpenButtonClick: function (item) {
      if (this.activeTab === '01') {
        this.initializeMode = true
        this.haisoMeisaiEditIndex = this.viewsData.vwHaisoMeisai.indexOf(item)
        this.viewsData.vwHaisoMeisai.map((elem) => {
          elem.selectRow = false
          return elem
        })
        this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex].selectRow = true
        this.recHaisoMeisai = Object.assign({}, item)
        // this.tempHaisoMeisai = this.recHaisoMeisai
        this.seikyuYoteiYmd = this.recHaisoMeisai.seikyuYoteiYmd

        this.hinmeiSwitch = Boolean(!this.recHaisoMeisai.mstHinmeiId && this.recHaisoMeisai.hinmeiBiko)
        this.hatsuchiSwitch = Boolean(!this.recHaisoMeisai.hatsuchiId && this.recHaisoMeisai.hatsuchiBiko)
        this.hatsuchiHmsSwitch = Boolean(!this.recHaisoMeisai.hatsuchiHms && this.recHaisoMeisai.hatsuchiHmsBiko)
        this.chakuchiSwitch = Boolean(!this.recHaisoMeisai.chakuchiId && this.recHaisoMeisai.chakuchiBiko)
        this.chakuchiHmsSwitch = Boolean(!this.recHaisoMeisai.chakuchiHms && this.recHaisoMeisai.chakuchiHmsBiko)
        this.expandKeiyuchi = Boolean(this.recHaisoMeisai.keiyuchiId2 || this.recHaisoMeisai.keiyuchiBiko2 || this.recHaisoMeisai.keiyuchiId3 || this.recHaisoMeisai.keiyuchiBiko3 || this.recHaisoMeisai.keiyuchiId4 || this.recHaisoMeisai.keiyuchiBiko4 || this.recHaisoMeisai.keiyuchiId5 || this.recHaisoMeisai.keiyuchiBiko5)

        if (this.recHaisoMeisai.taikiJikan !== null && this.recHaisoMeisai.taikiJikan !== undefined) {
          this.recHaisoMeisai.taikiJikan = this.calcTime(String(this.recHaisoMeisai.taikiJikan))
        }
        if (this.recHaisoMeisai.yoteiSagyoJikan !== null && this.recHaisoMeisai.yoteiSagyoJikan !== undefined) {
          this.recHaisoMeisai.yoteiSagyoJikan = this.calcTime(String(this.recHaisoMeisai.yoteiSagyoJikan))
        }
        if (this.recHaisoMeisai.warimashiTaishoJikan !== null && this.recHaisoMeisai.warimashiTaishoJikan !== undefined) {
          this.recHaisoMeisai.warimashiTaishoJikan = this.calcTime(String(this.recHaisoMeisai.warimashiTaishoJikan))
        }
        if (![undefined, null, ''].includes(this.recHaisoMeisai.jitsuUnsoTaiseiKanriList)) {
          this.recHaisoMeisai.jitsuUnsoTaiseiKanriList.map((elem) => {
            elem.tsumikomiYmd = filter.dateFormatter(elem.tsumikomiYmd)
            return elem
          })
          const dispRow = this.recHaisoMeisai.jitsuUnsoTaiseiKanriList.filter((elem) => {
            return elem.delFlg === false
          })

          this.recHaisoMeisai.dispJitsuUnsoTaiseiKanriList = Object.assign([], dispRow)
        }
      } else if (this.activeTab === '02') {
        this.nenryoEditIndex = this.viewsData.vwSharyoKeihiNenryohi.indexOf(item)
        this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
          elem.selectRow = false
          return elem
        })
        this.viewsData.vwSharyoKeihiNenryohi[this.nenryoEditIndex].selectRow = true
        this.recNenryo = Object.assign({}, item)
        // this.tempNenryo = this.recNenryo
      } else if (this.activeTab === '03') {
        this.tsukoryoEditIndex = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(item)
        this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
          elem.selectRow = false
          return elem
        })
        this.viewsData.vwSharyoKeihiTsukoryo[this.tsukoryoEditIndex].selectRow = true
        this.recTsukoryo = Object.assign({}, item)
        // this.tempTsukoryo = this.recTsukoryo
      }
    },
    onMeisaiDeleteButtonClick: function (item) {
      if (this.activeTab === '01') {
        const index = this.viewsData.vwHaisoMeisai.indexOf(item)
        this.recHaisoMeisai = Object.assign({}, item)
        this.recHaisoMeisai.delFlg = !this.recHaisoMeisai.delFlg
        Object.assign(this.viewsData.vwHaisoMeisai[index], this.recHaisoMeisai)
        if (this.recHaisoMeisai.delFlg) {
          this.initHaisoMeisai()
        } else {
          this.onMeisaiEditOpenButtonClick(item)
        }
      } else if (this.activeTab === '02') {
        const index = this.viewsData.vwSharyoKeihiNenryohi.indexOf(item)
        this.recNenryo = Object.assign({}, item)
        this.recNenryo.delFlg = !this.recNenryo.delFlg
        Object.assign(this.viewsData.vwSharyoKeihiNenryohi[index], this.recNenryo)
        if (this.recNenryo.delFlg) {
          this.initNenryo()
        } else {
          this.onMeisaiEditOpenButtonClick(item)
        }
      } else if (this.activeTab === '03') {
        const index = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(item)
        this.recTsukoryo = Object.assign({}, item)
        this.recTsukoryo.delFlg = !this.recTsukoryo.delFlg
        Object.assign(this.viewsData.vwSharyoKeihiTsukoryo[index], this.recTsukoryo)
        if (this.recTsukoryo.delFlg) {
          this.initTsukoryo()
        } else {
          this.onMeisaiEditOpenButtonClick(item)
        }
      }
    },
    onMeisaiDeleteFooterButtonClick: function () {
      if (this.activeTab === '01') {
        this.onMeisaiDeleteButtonClick(this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex])
      } else if (this.activeTab === '02') {
        this.onMeisaiDeleteButtonClick(this.viewsData.vwSharyoKeihiNenryohi[this.nenryoEditIndex])
      } else if (this.activeTab === '03') {
        this.onMeisaiDeleteButtonClick(this.viewsData.vwSharyoKeihiTsukoryo[this.tsukoryoEditIndex])
      }
    },
    onMeisaiCopyButtonClick: function (item) {
      if (this.activeTab === '01') {
        this.recHaisoMeisai = item
      } else if (this.activeTab === '02') {
        this.recNenryo = item
      } else if (this.activeTab === '03') {
        this.recTsukoryo = item
      }
      this.messageLessMode = 1
      this.onMeisaiCopyFooterButtonClick()
      this.onMeisaiSaveButtonClick()
    },
    onMeisaiCopyFooterButtonClick: function () {
      if (this.activeTab === '01') {
        this.viewsData.vwHaisoMeisai.map((elem) => {
          elem.selectRow = false
          return elem
        })
        this.tempHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
        this.tempHaisoMeisai.id = -1
        this.tempHaisoMeisai.tjmId = -1
        this.tempHaisoMeisai.tjhId = -1
        this.tempHaisoMeisai.tjkKinId = -1
        this.tempHaisoMeisai.tjmKinId = -1
        this.tempHaisoMeisai.tjhKinId = -1
        this.tempHaisoMeisai.tjrKihonId = -1
        this.tempHaisoMeisai.tjrMeisaiId = -1
        this.tempHaisoMeisai.tsmId = -1
        this.tempHaisoMeisai.tskMeisaiId = -1
        this.tempHaisoMeisai.tshId = -1
        this.tempHaisoMeisai.tskHinmokuId = -1
        this.tempHaisoMeisai.thkId = -1
        this.tempHaisoMeisai.thmId = -1
        this.tempHaisoMeisai.thkKinId = -1
        this.tempHaisoMeisai.thmKinId = -1
        this.tempHaisoMeisai.thhId = -1
        this.tempHaisoMeisai.thhKinId = -1
        this.tempHaisoMeisai.juchuNo = null
        this.tempHaisoMeisai.meisaiOrder = null
        this.tempHaisoMeisai.seikyuZumiFlg = false
        this.tempHaisoMeisai.shiharaiZumiFlg = false
        this.tempHaisoMeisai.jitsuUnsoTaiseiKanriList = []
        this.tempHaisoMeisai.dispJitsuUnsoTaiseiKanriList = []
        this.recHaisoMeisai = this.tempHaisoMeisai
        this.haisoMeisaiEditIndex = -1
      } else if (this.activeTab === '02') {
        this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
          elem.selectRow = false
          return elem
        })
        this.tempNenryo = Object.assign({}, this.recNenryo)
        this.tempNenryo.id = -1
        this.tempNenryo.trSharyoKeihiId = -1
        this.tempNenryo.sharyoKeihiNo = null
        this.tempNenryo.tekiyo5 = null
        this.recNenryo = this.tempNenryo
        this.nenryoEditIndex = -1
      } else if (this.activeTab === '03') {
        this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
          elem.selectRow = false
          return elem
        })
        this.tempTsukoryo = Object.assign({}, this.recTsukoryo)
        this.tempTsukoryo.id = -1
        this.tempTsukoryo.trSharyoKeihiId = -1
        this.tempTsukoryo.sharyoKeihiNo = null
        this.tempTsukoryo.tekiyo5 = null
        this.recTsukoryo = this.tempTsukoryo
        this.tsukoryoEditIndex = -1
      }
    },
    onMeisaiSaveButtonClick: function () {
      if (this.activeTab === '01') {
        if (!this.haisoMeisaiValidate()) { return }
        // this.tempHaisoMeisai = this.recHaisoMeisai
        // 更新時
        this.clearInvalidMessage(this.$refs)
        if (this.recHaisoMeisai.dispJitsuUnsoTaiseiKanriList.length > 0) {
          this.$refs.dispJitsuUnsoTaiseiKanriListComponent.convertKanriboResult(this.recHaisoMeisai)
        }
        if (this.recHaisoMeisai.meisaiOrder) {
          Object.assign(this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex], this.recHaisoMeisai)
        } else {
          // 新規追加時
          // this.recHaisoMeisai.id = -1
          this.recHaisoMeisai.delFlg = false
          this.recHaisoMeisai.selectRow = true
          this.meisaiCount++

          this.recHaisoMeisai.meisaiOrder = this.meisaiCount

          if (this.viewsData.vwHaisoMeisai.length > 0) {
            this.viewsData.vwHaisoMeisai.push(this.recHaisoMeisai)
          } else {
            this.viewsData.vwHaisoMeisai = [this.recHaisoMeisai]
          }
          this.haisoMeisaiEditIndex = this.viewsData.vwHaisoMeisai.indexOf(this.recHaisoMeisai)
        }

        if (this.recHaisoMeisai.taikiJikan !== null && this.recHaisoMeisai.taikiJikan !== undefined) {
          this.recHaisoMeisai.taikiJikan = this.calcTime(String(this.recHaisoMeisai.taikiJikan))
        }
        if (this.recHaisoMeisai.yoteiSagyoJikan !== null && this.recHaisoMeisai.yoteiSagyoJikan !== undefined) {
          this.recHaisoMeisai.yoteiSagyoJikan = this.calcTime(String(this.recHaisoMeisai.yoteiSagyoJikan))
        }

        if (this.recHaisoMeisai.warimashiTaishoJikan !== null && this.recHaisoMeisai.warimashiTaishoJikan !== undefined) {
          this.recHaisoMeisai.warimashiTaishoJikan = this.calcTime(String(this.recHaisoMeisai.warimashiTaishoJikan))
        }
        this.viewsData.vwHaisoMeisai.splice()
      } else if (this.activeTab === '02') {
        // this.tempNenryo = this.recNenryo
        if (this.recNenryo.tekiyo5) {
          // 更新時
          Object.assign(this.viewsData.vwSharyoKeihiNenryohi[this.nenryoEditIndex], this.recNenryo)
        } else {
          // 新規追加時
          this.recNenryo.id = -1
          this.recNenryo.delFlg = false
          this.recNenryo.selectRow = true
          this.nenryoCount++

          this.recNenryo.tekiyo5 = this.nenryoCount

          if (this.viewsData.vwSharyoKeihiNenryohi.length > 0) {
            this.viewsData.vwSharyoKeihiNenryohi.push(this.recNenryo)
          } else {
            this.viewsData.vwSharyoKeihiNenryohi = [this.recNenryo]
          }
          this.nenryoEditIndex = this.viewsData.vwSharyoKeihiNenryohi.indexOf(this.recNenryo)
        }
        this.viewsData.vwSharyoKeihiNenryohi.splice()
      } else if (this.activeTab === '03') {
        // this.tempTsukoryo = this.recTsukoryo
        if (this.recTsukoryo.tekiyo5) {
          // 更新時
          Object.assign(this.viewsData.vwSharyoKeihiTsukoryo[this.tsukoryoEditIndex], this.recTsukoryo)
        } else {
          // 新規追加時
          this.recTsukoryo.id = -1
          this.recTsukoryo.delFlg = false
          this.recTsukoryo.selectRow = true
          this.tsukoryoCount++

          this.recTsukoryo.tekiyo5 = this.tsukoryoCount

          if (this.viewsData.vwSharyoKeihiTsukoryo.length > 0) {
            this.viewsData.vwSharyoKeihiTsukoryo.push(this.recTsukoryo)
          } else {
            this.viewsData.vwSharyoKeihiTsukoryo = [this.recTsukoryo]
          }
          this.tsukoryoEditIndex = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(this.recTsukoryo)
        }
        this.viewsData.vwSharyoKeihiTsukoryo.splice()
      }
      if (this.messageLessMode === 0) {
        if (this.activeTab === '01') {
          modals.showAlert('PRMI0001', '', '', ['表示されている配送明細', '「保存」ボタンより登録処理'])
        } else if (this.activeTab === '02') {
          modals.showAlert('PRMI0001', '', '', ['表示されている燃料費', '「保存」ボタンより登録処理'])
        } else if (this.activeTab === '03') {
          modals.showAlert('PRMI0001', '', '', ['表示されている通行料', '「保存」ボタンより登録処理'])
        }
      }
      this.messageLessMode = 0
    },
    haisoMeisaiValidate: function () {
      var msg
      if (!this.recHaisoMeisai.juchuEigyoshoId) {
        this.$refs.juchuEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.recHaisoMeisai.tokuisakiId) {
        this.$refs.tokuisakiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.recHaisoMeisai.seikyuYoteiYmd) {
        this.$refs.seikyuYoteiYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (this.recHaisoMeisai.hatsuchiYmd && this.recHaisoMeisai.chakuchiYmd) {
        msg = validators.compareDate(this.recHaisoMeisai.hatsuchiYmd, this.recHaisoMeisai.chakuchiYmd)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.recHaisoMeisai.hatsuchiHms && this.recHaisoMeisai.chakuchiHms && !this.recHaisoMeisai.hatsuchiYmd && !this.recHaisoMeisai.chakuchiYmd) {
        msg = validators.compareTime(this.recHaisoMeisai.hatsuchiHms, this.recHaisoMeisai.chakuchiHms)
        if (msg !== undefined) {
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.recHaisoMeisai.hatsuchiYmd && this.recHaisoMeisai.hatsuchiHms && this.recHaisoMeisai.chakuchiYmd && this.recHaisoMeisai.chakuchiHms) {
        msg = validators.compareDateTime(this.recHaisoMeisai.hatsuchiYmd, this.recHaisoMeisai.hatsuchiHms, this.recHaisoMeisai.chakuchiYmd, this.recHaisoMeisai.chakuchiHms)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.custoMizeHaisoMeisaiValidate) {
        if (!this.custoMizeHaisoMeisaiValidate()) {
          return false
        }
      }
      return true
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id, keikakujissekikey: self.keikakujissekikey, trJuchuKihonId: self.trJuchuKihonId }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.id = self.cloneData.viewsData.vwSagyoJisseki.id
            self.viewsData = self.cloneData.viewsData
            self.recHaisoMeisai = self.cloneData.recHaisoMeisai
            self.recNenryo = self.cloneData.recNenryo
            self.recTsukoryo = self.cloneData.recTsukoryo
            self.meisaiCount = self.cloneData.meisaiCount
            self.nenryoCount = self.cloneData.nenryoCount
            self.tsukoryoCount = self.cloneData.tsukoryoCount
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            self.kakuninzumiMode = Boolean(self.cloneData.viewsData.vwSagyoJisseki.jissekiKakuninZumiFlg)
            self.seikyuZumiMode = Boolean(
              self.cloneData.viewsData.vwHaisoMeisai.find((t) => {
                return t.seikyuZumiFlg === true
              })
            )
            self.shiharaiZumiMode = Boolean(
              self.cloneData.viewsData.vwHaisoMeisai.find((t) => {
                return t.shiharaiZumiFlg === true
              })
            )
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      this.isHaisoMeisaiRequired = false
      this.$nextTick(function () {
        this.deleteAction()
      })
    },
    deleteAction: function (e) {
      this.tempViewsData = Object.assign({}, this.viewsData)
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            this.deleteMode = 1
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.kosokuJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.kosokuJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.kosokuJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.zangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.zangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.zangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.kyukeiJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.kyukeiJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.kosokuJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.kosokuJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.kosokuJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.zangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.zangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.zangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.kyukeiJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.kyukeiJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)
            }
            if (self.cloneData.viewsData.vwHaisoMeisai.length !== 0) {
              self.cloneData.viewsData.vwHaisoMeisai.forEach(p => {
                if (p.taikiJikan) {
                  p.taikiJikan = filter.timeToMinFormatter(p.taikiJikan)
                }
                if (p.yoteiSagyoJikan) {
                  p.yoteiSagyoJikan = filter.timeToMinFormatter(p.yoteiSagyoJikan)
                }
                if (p.warimashiTaishoJikan) {
                  p.warimashiTaishoJikan = filter.timeToMinFormatter(p.warimashiTaishoJikan)
                }
              })
            }
            self.viewsData = self.cloneData.viewsData
            self.HttpClient.post('/api/v1/D2PRMD0020/JuchuWithJissekiDelete', self.viewsData).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id, keikakujissekikey: self.keikakujissekikey, trJuchuKihonId: self.trJuchuKihonId }
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.viewsData = this.tempViewsData
            this.convertToDispType()
            this.deleteMode = 0
            this.isHaisoMeisaiRequired = true
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        const inputData = Object.assign({}, this.viewsData)
        inputData.vwUnkoJisseki.id = -1
        inputData.vwUnkoJisseki.unkoJissekiNo = null
        inputData.vwSagyoJisseki.id = -1
        inputData.vwKintaiJissekiJomuin.id = -1
        inputData.vwKintaiJissekiJoshu.id = -1
        /*
        const inputHaisoData = Object.assign({}, this.recHaisoMeisai)
        inputHaisoData.id = -1
        inputHaisoData.tjmId = null
        inputHaisoData.tjhId = null
        inputHaisoData.tjkKinId = null
        inputHaisoData.tjmKinId = null
        inputHaisoData.tjhKinId = null
        inputHaisoData.tjrKihonId = null
        inputHaisoData.tjrMeisaiId = null
        inputHaisoData.tsmId = null
        inputHaisoData.tskMeisaiId = null
        inputHaisoData.tshId = null
        inputHaisoData.tskHinmokuId = null
        inputHaisoData.thkId = null
        inputHaisoData.thmId = null
        inputHaisoData.thkKinId = null
        inputHaisoData.thmKinId = null
        inputHaisoData.juchuNo = null
        inputHaisoData.meisaiOrder = null
        this.recHaisoMeisai = Object.assign({}, inputHaisoData)
        this.recNenryo.id = -1
        this.recNenryo.sharyoKeihiNo = null
        this.recTsukoryo.id = -1
        this.recTsukoryo.sharyoKeihiNo = null
        */
        if (inputData.vwHaisoMeisai.length > 0) {
          inputData.vwHaisoMeisai.forEach(p => {
            p.id = -1
            p.tjmId = -1
            p.tjhId = -1
            p.tjkKinId = -1
            p.tjmKinId = -1
            p.tjhKinId = -1
            p.tjrKihonId = -1
            p.tjrMeisaiId = -1
            p.tsmId = -1
            p.tskMeisaiId = -1
            p.tshId = -1
            p.tskHinmokuId = -1
            p.thkId = -1
            p.thmId = -1
            p.thkKinId = -1
            p.thmKinId = -1
            p.thhId = -1
            p.thhKinId = -1
            p.juchuNo = null
            // p.meisaiOrder = null
            p.seikyuZumiFlg = false
            p.shiharaiZumiFlg = false
            p.jitsuUnsoTaiseiKanriList = []
            p.dispJitsuUnsoTaiseiKanriList = []
          })
        }
        if (inputData.vwSharyoKeihiNenryohi.length > 0) {
          inputData.vwSharyoKeihiNenryohi.forEach(p => {
            p.id = -1
            p.trSharyoKeihiId = -1
            p.sharyoKeihiNo = null
            // p.tekiyo5 = null
          })
        }
        if (inputData.vwSharyoKeihiTsukoryo.length > 0) {
          inputData.vwSharyoKeihiTsukoryo.forEach(p => {
            p.id = -1
            p.trSharyoKeihiId = -1
            p.sharyoKeihiNo = null
            // p.tekiyo5 = null
          })
        }
        this.viewsData = Object.assign({}, inputData)
        this.initHaisoMeisai()
        this.initNenryo()
        this.initTsukoryo()
        this.activeTab = '01'
        this.tab = '#tab1'
        this.id = -1
        if (this.viewsData.vwHaisoMeisai.length > 0) {
          this.onMeisaiEditOpenButtonClick(this.viewsData.vwHaisoMeisai[0])
        }
        this.kakuninzumiMode = false
        this.seikyuZumiMode = false
        this.shiharaiZumiMode = false
        this.Effects.loadComplete()
      })
    },
    onSaveButtonClick: function (e) {
      if (this.activeTab === '01') {
        const targetMeisai = this.viewsData.vwHaisoMeisai.find(({ selectRow }) => selectRow === true)
        if (targetMeisai) {
          if (targetMeisai !== this.recHaisoMeisai) {
            if (!this.haisoMeisaiValidate()) { return }
            this.messageLessMode = 1
            this.onMeisaiSaveButtonClick()
          }
        } else {
          const targetHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
          const initHaisoMeisai = {
            unchinKakuteiFlg: false,
            seikyuTomeFlg: false,
            juchuEigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id,
            tokuisakiId: null,
            mstHinmeiId: null,
            hatsuchiId: null,
            chakuchiId: null,
            keiyuchiId1: null,
            keiyuchiId2: null,
            keiyuchiId3: null,
            keiyuchiId4: null,
            keiyuchiId5: null,
            seikyuYoteiYmd: filter.dateFormatter(new Date()),
            jikanWarimashiKingaku: 0,
            kyoriWarimashiKingaku: 0
          }
          const initHaisoMeisaiJson = JSON.stringify(Object.entries(initHaisoMeisai).sort())
          const targetHaisoMeisaiJson = JSON.stringify(Object.entries(targetHaisoMeisai).sort())
          if (initHaisoMeisaiJson !== targetHaisoMeisaiJson) {
            if (!this.haisoMeisaiValidate()) { return }
            this.messageLessMode = 1
            this.onMeisaiSaveButtonClick()
          }
        }
      } else if (this.activeTab === '02') {
        const targetNenryo = this.viewsData.vwSharyoKeihiNenryohi.find(({ selectRow }) => selectRow === true)
        if (targetNenryo) {
          if (targetNenryo !== this.recNenryo) {
            this.messageLessMode = 1
            this.onMeisaiSaveButtonClick()
          }
        } else {
          const initNenryo = {
            torihikisakiId: null
          }
          const initNenryoJson = JSON.stringify(Object.entries(initNenryo).sort())
          const targetNenryoJson = JSON.stringify(Object.entries(this.recNenryo).sort())

          if (initNenryoJson !== targetNenryoJson) {
            this.messageLessMode = 1
            this.onMeisaiSaveButtonClick()
          }
        }
      } else if (this.activeTab === '03') {
        const targetTsukoryo = this.viewsData.vwSharyoKeihiTsukoryo.find(({ selectRow }) => selectRow === true)
        if (targetTsukoryo) {
          if (targetTsukoryo !== this.recTsukoryo) {
            this.messageLessMode = 1
            this.onMeisaiSaveButtonClick()
          }
        } else {
          const initTsukoryo = {
          }
          const initTsukoryoJson = JSON.stringify(Object.entries(initTsukoryo).sort())
          const targetTsukoryoJson = JSON.stringify(Object.entries(this.recTsukoryo).sort())

          if (initTsukoryoJson !== targetTsukoryoJson) {
            this.messageLessMode = 1
            this.onMeisaiSaveButtonClick()
          }
        }
      }
      this.isHaisoMeisaiRequired = false
      this.initializeMode = true
      this.$nextTick(function () {
        this.registerAction()
      })
    },
    registerAction: function (e) {
      console.log('save', this)
      const self = this
      self.tempViewsData = Object.assign({}, self.viewsData)
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            if (data.isValid) {
              const inputData = {}
              inputData.vwUnkoJisseki = data.payload.vwUnkoJisseki
              self.id = inputData.vwUnkoJisseki.id
              self.isHaisoMeisaiRequired = true
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            if (self.id < 1) {
              if (self.custoMizeInitBindVariables) {
                self.custoMizeInitBindVariables()
              } else {
                self.initBindVariables()
              }
              self.transition(1, { id: [0, '0'] }, self.initialize)
            } else {
              // self.fetchData()
              // self.Effects.loadComplete()
              self.transition(1, { id: [self.id, '0'] }, self.initialize)
            }
            console.log('★transition')
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id, keikakujissekikey: self.keikakujissekikey }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          if (self.custoMizeGetSavedInputMethod) {
            return self.custoMizeGetSavedInputMethod()
          }
          return {}
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            self.viewsData = self.tempViewsData
            self.convertToDispType()
            self.isHaisoMeisaiRequired = true
            resolve()
          })
        }
      }
      self.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/D2PRMD0020/JuchuWithJissekiCreate', this.viewsData)
      return f
    },
    registerValidate: function () {
      var msg
      if (this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && this.viewsData.vwUnkoJisseki.jissekiKikoYmd && !this.viewsData.vwUnkoJisseki.jissekiShukkoHms && !this.viewsData.vwUnkoJisseki.jissekiKikoHms) {
        msg = validators.compareDate(this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoYmd)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwUnkoJisseki.jissekiShukkoHms && this.viewsData.vwUnkoJisseki.jissekiKikoHms && !this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && !this.viewsData.vwUnkoJisseki.jissekiKikoYmd) {
        msg = validators.compareTime(this.viewsData.vwUnkoJisseki.jissekiShukkoHms, this.viewsData.vwUnkoJisseki.jissekiKikoHms)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && this.viewsData.vwUnkoJisseki.jissekiShukkoHms && this.viewsData.vwUnkoJisseki.jissekiKikoYmd && this.viewsData.vwUnkoJisseki.jissekiKikoHms) {
        msg = validators.compareDateTime(this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiShukkoHms, this.viewsData.vwUnkoJisseki.jissekiKikoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoHms)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwUnkoJisseki.hatsuchiOdoMater && this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
        msg = validators.compareNumerical(parseFloat(this.viewsData.vwUnkoJisseki.hatsuchiOdoMater), parseFloat(this.viewsData.vwUnkoJisseki.chakuchiOdoMater))
        if (msg !== undefined) {
          this.$refs.hatsuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    deleteValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      // 基準日初期値設定
      this.baseYmd = date.getCurrentDate()
      // this.modeKengen = 0
      this.deleteMode = 0
      // this.modeOfEdit = 0
      this.kakuninzumiMode = false
      this.seikyuZumiMode = false
      this.shiharaiZumiMode = false
      this.haishaEigyoshoCd = this.usersEigyosho
      this.jomuinKinmuTeateKingakuAmount = 0
      this.joshuKinmuTeateKingakuAmount = 0
      this.jishaSharyoSbt = ''
      this.yoshaSharyoSbt = ''
      this.tempViewsData = {}
      this.lastUnkoJissekiInfo = {}
      this.jiEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id : null
      const initData = {
        vwUnkoJisseki: {
          unkoYmd: filter.dateFormatter(new Date()),
          haishaKbn: '01',
          sharyoId: null,
          hacchusakiShaban: null,
          hacchusakiShashuSbt: null,
          hatsuchiOdoMater: '',
          chakuchiOdoMater: '',
          sokoKyori: 0,
          jisshaKyori: 0,
          jissekiShukkoYmd: '',
          jissekiShukkoHms: '',
          jissekiKikoYmd: '',
          jissekiKikoHms: '',
          hacchusakiId: null,
          hacchusakiJomuinId: null
        },
        vwSagyoJisseki: {
          jissekiKakuninZumiFlg: false,
          torokuTantoshaId: this.usersId,
          eigyoshoId: null
        },
        vwKintaiJissekiJomuin: {
          jininId: '',
          shuroKbn: null,
          kosokuJikan: null,
          zangyoJikan: null,
          shinyaJikan: null,
          shinyaZangyoJikan: null,
          kyukeiJikan: null,
          kinmuTeateKingaku1: null,
          kinmuTeateKingaku2: null,
          kinmuTeateKingaku3: null,
          kinmuTeateKingaku4: null,
          kinmuTeateKingaku5: null,
          kinmuTeateKingaku6: null,
          kinmuTeateKingaku7: null,
          kinmuTeateKingaku8: null
        },
        vwKintaiJissekiJoshu: {
          jininId: '',
          shuroKbn: null,
          kosokuJikan: null,
          zangyoJikan: null,
          shinyaJikan: null,
          shinyaZangyoJikan: null,
          kyukeiJikan: null,
          kinmuTeateKingaku1: null,
          kinmuTeateKingaku2: null,
          kinmuTeateKingaku3: null,
          kinmuTeateKingaku4: null,
          kinmuTeateKingaku5: null,
          kinmuTeateKingaku6: null,
          kinmuTeateKingaku7: null,
          kinmuTeateKingaku8: null
        },
        vwHaisoMeisai: [],
        trSagyoKeikakuJininList: [],
        trSagyoKeikakuMeisaiList: [],
        vwSharyoKeihiNenryohi: [],
        vwSharyoKeihiTsukoryo: []
      }
      this.viewsData = Object.assign({}, initData)
      this.seikyuYoteiYmd = filter.dateFormatter(new Date())
      this.initHaisoMeisai()
      if (this.custoMizeHaisoMeisaiInit) { this.custoMizeHaisoMeisaiInit() }
      this.recNenryo = {}
      this.recTsukoryo = {}
      this.recNenryo.torihikisakiId = null
      this.registerMode = 0
      this.isJishaHaishaMode = true
      this.isJiEigyoshoMode = true
      this.isHokaEigyoshoMode = false
      this.isHaisoMeisaiRequired = true
      this.yoshaSharyoSwitch = false
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.expandKeiyuchi = false
      // this.tab = '#tab1'
      // this.activeTab = '01'
      // 権限制御
      this.isReadOnlyCommon = false
      this.isReadOnlyJisha = false
      this.isReadOnlyYosha = false
    },
    initHaisoMeisai: function () {
      this.clearInvalidMessage(this.$refs)
      this.viewsData.vwHaisoMeisai.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.recHaisoMeisai = {}
      this.tempHaisoMeisai = {}
      this.recTokuisakiInfo = {}
      this.isHaisoMeisaiRequired = true
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.expandKeiyuchi = false
      this.haisoMeisaiEditIndex = -1
      this.$set(this, 'recHaisoMeisai', {
        unchinKakuteiFlg: false,
        seikyuTomeFlg: false,
        juchuEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id : null,
        teikeiKihonNo: null,
        tokuisakiId: null,
        ohfukuSbt: null,
        hatsuchiId: null,
        chakuchiId: null,
        keiyuchiId1: null,
        keiyuchiId2: null,
        keiyuchiId3: null,
        keiyuchiId4: null,
        keiyuchiId5: null,
        mstHinmeiId: null,
        unitKbn: null,
        unchinKeisanKbn: null,
        seikyuShashuSbt: null,
        nenryoSurcharge: null,
        tsumikomiKingaku: null,
        torioroshiKingaku: null,
        taikiJikan: null,
        taikiJikanTanka: null,
        taikiJikanKingaku: null,
        futaiGyomuKingaku: null,
        futaiGyomuKingaku1: null,
        futaiGyomuKingaku2: null,
        futaiGyomuKingaku3: null,
        futaiGyomuKingaku4: null,
        futaiGyomuKingaku5: null,
        futaiGyomuKingaku6: null,
        futaiGyomuKingaku7: null,
        futaiGyomuKingaku8: null,
        futaiGyomuKingaku9: null,
        futaiGyomuKingaku10: null,
        motoukeFlg: true,
        jitsuUnsoTaiseiKanriList: [],
        dispJitsuUnsoTaiseiKanriList: [],
        jikanWarimashiKingaku: 0,
        kyoriWarimashiKingaku: 0
      })
      this.seikyuYoteiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      if (this.custoMizeHaisoMeisaiInit) { this.custoMizeHaisoMeisaiInit() }
      this.tempHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
    },
    initNenryo: function () {
      this.clearInvalidMessage(this.$refs)
      this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.recNenryo = {}
      this.tempNenryo = {}
      this.recNenryo.torihikisakiId = null
      this.nenryoEditIndex = -1
      this.tempNenryo = Object.assign({}, this.recNenryo)
    },
    initTsukoryo: function () {
      this.clearInvalidMessage(this.$refs)
      this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.recTsukoryo = {}
      this.tempTsukoryo = {}
      this.tsukoryoEditIndex = -1
      this.tempTsukoryo = Object.assign({}, this.recTsukoryo)
    },
    // パラメタ取得用
    setFromParameters: function (parms) {
      return new Promise((resolve) => {
        var args
        if (typeof (parms) === 'string') {
          args = parms.split('/')
        } else if (Array.isArray(parms)) {
          args = parms
        } else if (typeof (parms) === 'number') {
          this.id = parms
          return
        } else {
          console.warn('★undefined way to parm...')
          return
        }
        if (args.length === 0) {
          this.id = 0
          this.keikakujissekikey = '0'
          this.trJuchuKihonId = 0
        } else if (args.length === 1) {
          this.id = args[0]
          if (this.id === '0') {
            this.id = 0
          }
          this.keikakujissekikey = '0'
          this.trJuchuKihonId = 0
        } else if (args.length === 2) {
          this.id = args[0]
          if (this.id === '0') {
            this.id = 0
          }
          this.keikakujissekikey = args[1]
          this.trJuchuKihonId = 0
        } else if (args.length >= 3) {
          this.id = args[0]
          if (this.id === '0') {
            this.id = 0
          }
          this.keikakujissekikey = args[1]
          this.trJuchuKihonId = args[2]
        }
        console.log('ids', this.id, this.keikakujissekikey, this.trJuchuKihonId)
        resolve()
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // DB処理用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDBType: function () {
      const tmpData = Object.assign({}, this.viewsData)
      if (tmpData.vwKintaiJissekiJomuin.kosokuJikan) {
        tmpData.vwKintaiJissekiJomuin.kosokuJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.kosokuJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.zangyoJikan) {
        tmpData.vwKintaiJissekiJomuin.zangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.zangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.shinyaJikan) {
        tmpData.vwKintaiJissekiJomuin.shinyaJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.shinyaJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
        tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.kyukeiJikan) {
        tmpData.vwKintaiJissekiJomuin.kyukeiJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.kyukeiJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.kosokuJikan) {
        tmpData.vwKintaiJissekiJoshu.kosokuJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.kosokuJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.zangyoJikan) {
        tmpData.vwKintaiJissekiJoshu.zangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.zangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.shinyaJikan) {
        tmpData.vwKintaiJissekiJoshu.shinyaJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.shinyaJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
        tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.kyukeiJikan) {
        tmpData.vwKintaiJissekiJoshu.kyukeiJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.kyukeiJikan)
      }
      if (tmpData.vwHaisoMeisai.length !== 0) {
        tmpData.vwHaisoMeisai.forEach(p => {
          if (p.taikiJikan) {
            p.taikiJikan = filter.timeToMinFormatter(p.taikiJikan)
          }
          if (p.yoteiSagyoJikan) {
            p.yoteiSagyoJikan = filter.timeToMinFormatter(p.yoteiSagyoJikan)
          }
          if (p.warimashiTaishoJikan) {
            p.warimashiTaishoJikan = filter.timeToMinFormatter(p.warimashiTaishoJikan)
          }
          if (p.dispJitsuUnsoTaiseiKanriList.length > 0) {
            this.$refs.dispJitsuUnsoTaiseiKanriListComponent.convertKanriboResult(p)
          }
        })
      }
      this.viewsData = Object.assign({}, tmpData)
    },
    // ----------------------------------------------------------------------------------------------------
    // 画面表示用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDispType: function () {
      return new Promise(resolve => {
        const tmpData = Object.assign({}, this.viewsData)
        if (tmpData.vwUnkoJisseki.unkoYmd) {
          tmpData.vwUnkoJisseki.unkoYmd = filter.dateFormatter(tmpData.vwUnkoJisseki.unkoYmd)
        }
        if (tmpData.vwUnkoJisseki.jissekiShukkoYmd) {
          tmpData.vwUnkoJisseki.jissekiShukkoYmd = filter.dateFormatter(tmpData.vwUnkoJisseki.jissekiShukkoYmd)
        }
        if (tmpData.vwUnkoJisseki.jissekiShukkoHms) {
          tmpData.vwUnkoJisseki.jissekiShukkoHms = complements.parseTime(tmpData.vwUnkoJisseki.jissekiShukkoHms, false).substr(0, 5)
        }
        if (tmpData.vwUnkoJisseki.jissekiKikoYmd) {
          tmpData.vwUnkoJisseki.jissekiKikoYmd = filter.dateFormatter(tmpData.vwUnkoJisseki.jissekiKikoYmd)
        }
        if (tmpData.vwUnkoJisseki.jissekiKikoHms) {
          tmpData.vwUnkoJisseki.jissekiKikoHms = complements.parseTime(tmpData.vwUnkoJisseki.jissekiKikoHms, false).substr(0, 5)
        }
        if (tmpData.vwKintaiJissekiJomuin.kosokuJikan) {
          tmpData.vwKintaiJissekiJomuin.kosokuJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.kosokuJikan)
        }
        if (tmpData.vwKintaiJissekiJomuin.zangyoJikan) {
          tmpData.vwKintaiJissekiJomuin.zangyoJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.zangyoJikan)
        }
        if (tmpData.vwKintaiJissekiJomuin.shinyaJikan) {
          tmpData.vwKintaiJissekiJomuin.shinyaJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.shinyaJikan)
        }
        if (tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
          tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan)
        }
        if (tmpData.vwKintaiJissekiJomuin.kyukeiJikan) {
          tmpData.vwKintaiJissekiJomuin.kyukeiJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.kyukeiJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.kosokuJikan) {
          tmpData.vwKintaiJissekiJoshu.kosokuJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.kosokuJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.zangyoJikan) {
          tmpData.vwKintaiJissekiJoshu.zangyoJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.zangyoJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.shinyaJikan) {
          tmpData.vwKintaiJissekiJoshu.shinyaJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.shinyaJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
          tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.kyukeiJikan) {
          tmpData.vwKintaiJissekiJoshu.kyukeiJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.kyukeiJikan)
        }
        if (tmpData.vwHaisoMeisai.length > 0) {
          tmpData.vwHaisoMeisai.forEach(p => {
            if (p.hatsuchiYmd) {
              p.hatsuchiYmd = filter.dateFormatter(p.hatsuchiYmd)
            }
            if (p.hatsuchiHms) {
              p.hatsuchiHms = complements.parseTime(p.hatsuchiHms, false).substr(0, 5)
            }
            if (p.chakuchiYmd) {
              p.chakuchiYmd = filter.dateFormatter(p.chakuchiYmd)
            }
            if (p.chakuchiHms) {
              p.chakuchiHms = complements.parseTime(p.chakuchiHms, false).substr(0, 5)
            }
            if (p.seikyuYoteiYmd) {
              p.seikyuYoteiYmd = filter.dateFormatter(p.seikyuYoteiYmd)
            }
            if (p.yoteiSagyoJikan) {
              p.yoteiSagyoJikan = filter.minToIntervalTimeFormatter(p.yoteiSagyoJikan)
            }
            if (p.taikiJikan) {
              p.taikiJikan = filter.minToIntervalTimeFormatter(p.taikiJikan)
            }
            if (p.warimashiTaishoJikan) {
              p.warimashiTaishoJikan = filter.minToIntervalTimeFormatter(p.warimashiTaishoJikan)
            }
            if (p.motoukeHokokuYmd) {
              p.motoukeHokokuYmd = filter.dateFormatter(p.motoukeHokokuYmd)
            }
            p.selectRow = false
          })
        }
        if (tmpData.vwSharyoKeihiNenryohi.length > 0) {
          tmpData.vwSharyoKeihiNenryohi.forEach(p => {
            p.selectRow = false
          })
        }
        if (tmpData.vwSharyoKeihiTsukoryo.length > 0) {
          tmpData.vwSharyoKeihiTsukoryo.forEach(p => {
            p.selectRow = false
          })
        }
        this.viewsData = Object.assign({}, tmpData)
        this.onChangeHaishaKbn()
        resolve()
      })
    },
    onChangeHaishaKbn: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '01') {
        this.isJishaHaishaMode = true
        this.isJiEigyoshoMode = true
        this.isHokaEigyoshoMode = false
        // this.haishaEigyoshoCd = this.usersEigyosho
        this.viewsData.vwSagyoJisseki.eigyoshoId = null
        this.$set(this, 'haishaEigyoshoCd', this.usersEigyosho)
        if (!this.recHaisoMeisai.meisaiOrder) {
          this.recHaisoMeisai.juchuEigyoshoId = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id
        }
      } else if (this.viewsData.vwUnkoJisseki.haishaKbn === '02') {
        this.isJishaHaishaMode = true
        this.isJiEigyoshoMode = false
        this.isHokaEigyoshoMode = true
        this.inputIraisakiEigyosho()
      } else if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.isJishaHaishaMode = false
        this.isJiEigyoshoMode = false
        this.isHokaEigyoshoMode = false
        this.viewsData.vwSagyoJisseki.eigyoshoId = null
        // this.haishaEigyoshoCd = this.usersEigyosho
        this.$set(this, 'haishaEigyoshoCd', this.usersEigyosho)
        this.yoshaSharyoSwitch = Boolean(!this.viewsData.vwUnkoJisseki.sharyoId && this.viewsData.vwUnkoJisseki.hacchusakiShaban)
        if (!this.recHaisoMeisai.meisaiOrder) {
          this.recHaisoMeisai.juchuEigyoshoId = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id
        }
      }
      let header = []
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '', value: 'selectRow' },
          { text: 'No', value: 'meisaiOrder' },
          { text: '得意先', value: 'dispTokuisaki' },
          { text: '発地', value: 'dispHatsuchi' },
          { text: '発地日時', value: 'dispHatsuchiYmd' },
          { text: '着地', value: 'dispChakuchi' },
          { text: '着地日時', value: 'dispChakuchiYmd' },
          { text: '品名', value: 'dispHinmei' },
          { text: '数量', value: 'dispJuchuSuryo', align: 'right' },
          { text: '単位', value: 'dispUnitKbnNm' },
          { text: '重量', value: 'dispjuchuJuryo', align: 'right' },
          { text: '単価', value: 'dispTanka', align: 'right' },
          { text: '運賃', value: 'dispKihonUnchin', align: 'right' },
          { text: '高速代', value: 'dispHiwayPrice', align: 'right' },
          { text: '運賃合計', value: 'dispUnchinGokei', align: 'right' },
          { text: '荷主書面(受)', value: 'dispChumonshoReceiveZumiFlg', align: 'center' },
          { text: '荷主書面(交付)', value: 'dispChumonkakuninshoSendZumiFlg', align: 'center' },
          { text: '傭車書面(交付)', value: 'dispHacchushoSendZumiFlg', align: 'center' },
          { text: '操作', value: 'actions', sortable: false, width: '20px' }
        ]
      } else {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '', value: 'selectRow' },
          { text: 'No', value: 'meisaiOrder' },
          { text: '得意先', value: 'dispTokuisaki' },
          { text: '発地', value: 'dispHatsuchi' },
          { text: '発地日時', value: 'dispHatsuchiYmd' },
          { text: '着地', value: 'dispChakuchi' },
          { text: '着地日時', value: 'dispChakuchiYmd' },
          { text: '品名', value: 'dispHinmei' },
          { text: '数量', value: 'dispJuchuSuryo', align: 'right' },
          { text: '単位', value: 'dispUnitKbnNm' },
          { text: '重量', value: 'dispjuchuJuryo', align: 'right' },
          { text: '単価', value: 'dispTanka', align: 'right' },
          { text: '運賃', value: 'dispKihonUnchin', align: 'right' },
          { text: '高速代', value: 'dispHiwayPrice', align: 'right' },
          { text: '運賃合計', value: 'dispUnchinGokei', align: 'right' },
          { text: '荷主書面(受)', value: 'dispChumonshoReceiveZumiFlg', align: 'center' },
          { text: '荷主書面(交付)', value: 'dispChumonkakuninshoSendZumiFlg', align: 'center' },
          { text: '実運送報告', value: 'dispMotoukeHokokuZumiFlg', align: 'center' },
          { text: '操作', value: 'actions', sortable: false, width: '20px' }
        ]
      }
      this.haisoMeisaiListHeaders = Object.assign([], header)
    },
    inputKosokuJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.kosokuJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kosokuJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.kosokuJikan)))
      }
    },
    inputZangyoJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.zangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'zangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.zangyoJikan)))
      }
    },
    inputShinyaJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.shinyaJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'shinyaJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.shinyaJikan)))
      }
    },
    inputShinyaZangyoJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'shinyaZangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan)))
      }
    },
    inputKyukeiJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kyukeiJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)))
      }
      this.inputAttendanceTimesElement()
    },
    inputKosokuJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.kosokuJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kosokuJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.kosokuJikan)))
      }
    },
    inputZangyoJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.zangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'zangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.zangyoJikan)))
      }
    },
    inputShinyaJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.shinyaJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'shinyaJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.shinyaJikan)))
      }
    },
    inputShinyaZangyoJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'shinyaZangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan)))
      }
    },
    inputKyukeiJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kyukeiJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)))
      }
      this.inputAttendanceTimesElement()
    },
    inputYoteiSagyoJikan: function () {
      if (this.recHaisoMeisai.yoteiSagyoJikan) {
        this.$set(this.recHaisoMeisai, 'yoteiSagyoJikan', this.calcTime(String(this.recHaisoMeisai.yoteiSagyoJikan)))
      }
    },
    inputTaikiJikan: function () {
      if (this.recHaisoMeisai.taikiJikan) {
        this.$set(this.recHaisoMeisai, 'taikiJikan', this.calcTime(String(this.recHaisoMeisai.taikiJikan)))
      }
    },
    inputWarimashiTaishoJikan: function () {
      if (this.recHaisoMeisai.warimashiTaishoJikan) {
        this.$set(this.recHaisoMeisai, 'warimashiTaishoJikan', this.calcTime(String(this.recHaisoMeisai.warimashiTaishoJikan)))
      }
    },
    setJuchuEigyosho: function () {
      if (this.recHaisoMeisai.juchuEigyoshoId) {
        this.recHaisoMeisai.juchuEigyoshoCd = indexeddb.getRecord(this.eigyoshoList, this.recHaisoMeisai.juchuEigyoshoId).eigyoshoCd
      }
    },
    setYoshaInfo: function () {
      this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputYoshaInfo()

      if (this.viewsData.vwHaisoMeisai.length > 1) {
        const hacchusakiInfo = indexeddb.getRecord(this.torihikisakiList, this.viewsData.vwUnkoJisseki.hacchusakiId)
        const yoshaSharyoInfo = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId)
        const yoshaJininInfo = indexeddb.getRecord(this.eigyoshoJininList, this.viewsData.vwUnkoJisseki.hacchusakiJomuinId)

        this.viewsData.vwHaisoMeisai.forEach((meisai, mIndex) => {
          if (!meisai.motoukeFlg) return

          // 先頭のインデックスを取得
          const kIndex = meisai.jitsuUnsoTaiseiKanriList.findIndex(kanri => kanri.delFlg === false)

          if (kIndex === -1) return

          this.$set(
            this.viewsData.vwHaisoMeisai[mIndex].jitsuUnsoTaiseiKanriList,
            kIndex,
            {
              ...meisai.jitsuUnsoTaiseiKanriList[kIndex],
              jitsuUnsoJigyoshaNm: ![undefined, null, ''].includes(hacchusakiInfo) ? hacchusakiInfo.torihikisakiNm : '',
              jitsuUnsoSharyoNm: ![undefined, null, ''].includes(yoshaSharyoInfo) ? yoshaSharyoInfo.jidoshaHyojiNm : this.viewsData.vwUnkoJisseki.hacchusakiShaban,
              jitsuUnsoJomuinNm: ![undefined, null, ''].includes(yoshaJininInfo) ? yoshaJininInfo.jininNmSei : ''
            }
          )
        })
      }
    },
    setHinmei: function () {
      if (this.recHaisoMeisai.mstHinmeiId) {
        const hinmeiInfo = indexeddb.getRecord(this.hinmeiList, this.recHaisoMeisai.mstHinmeiId)
        this.recHaisoMeisai.hinmeiCd = hinmeiInfo.hinmeiCd
        if (!this.recHaisoMeisai.tanka) {
          this.$set(this.recHaisoMeisai, 'tanka', hinmeiInfo.tanka)
        }
        if (!this.recHaisoMeisai.unchinKeisanKbn) {
          this.$set(this.recHaisoMeisai, 'unchinKeisanKbn', hinmeiInfo.unchinKeisanKbn)
        }
      }
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputHinmei()
      }
    },
    setHatsuchiId: function () {
      if (this.recHaisoMeisai.hatsuchiId) {
        this.recHaisoMeisai.hatsuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.recHaisoMeisai.hatsuchiId).hacchakuchiCd
      }
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputHacchakuchi()
      }
    },
    setChakuchiId: function () {
      if (this.recHaisoMeisai.chakuchiId) {
        this.recHaisoMeisai.chakuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.recHaisoMeisai.chakuchiId).hacchakuchiCd
      }
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputHacchakuchi()
      }
    },
    setHachhakuchiTanka: function (e) {
      let temp = Object.assign({}, this.recHaisoMeisai)
      temp = {
        ...temp,
        /*
        juchuEigyoshoId: e.eigyoshoCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', e.eigyoshoCd, this.baseYmd).id : temp.juchuEigyoshoId,
        tokuisakiId: e.torihikisakiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', e.torihikisakiCd, this.baseYmd).id : temp.tokuisakiId,
        mstHinmeiId: e.hinmeiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.hinmeiList, 'hinmeiCd', e.hinmeiCd, this.baseYmd).id : temp.mstHinmeiId,
        seikyuShashuSbt: e.unchinShashuSbt,
        */
        unchinKeisanKbn: e.unchinKeisanKbn,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        hokanKingaku: e.userKingakuKazei4,
        niekiKingaku: e.userKingakuKazei3,
        unchinHokaKingaku: e.userKingakuKazei1,
        unchinHokaHikazei: e.userKingakuHikazei1,
        tatekaekinHikazei: e.userKingakuHikazei2,
        warimashiSonotaKingsku: e.userKingakuKazei2
      }
      this.recHaisoMeisai = Object.assign({}, temp)
      temp = undefined
      if (this.custoMizeSetHachhakuchiTanka) {
        this.custoMizeSetHachhakuchiTanka()
      }
    },
    setYoteiSokoKyori: function (e) {
      this.$set(this.recHaisoMeisai, 'yoteiSokoKyori', e.kyoriKm)
    },
    calcTime: function (p) {
      if (this.deleteMode !== 0) { return }
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    },
    onSwitchingYoshaSharyoMstToTegakiNo (f) {
      this.yoshaSharyoSwitch = f
    },
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },

    // ----------------------------------------------------------------------------------------------------
    // GoogleMapリンク
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiId) || ![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiBiko)) {
        const hatsuchi = {
          id: this.recHaisoMeisai.hatsuchiId,
          biko: this.recHaisoMeisai.hatsuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko1)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId1,
          biko: this.recHaisoMeisai.keiyuchiBiko1,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko2)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId2,
          biko: this.recHaisoMeisai.keiyuchiBiko2,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko3)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId3,
          biko: this.recHaisoMeisai.keiyuchiBiko3,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId4) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko4)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId4,
          biko: this.recHaisoMeisai.keiyuchiBiko4,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId5) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko5)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId5,
          biko: this.recHaisoMeisai.keiyuchiBiko5,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiId) || ![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiBiko)) {
        const chakuchi = {
          id: this.recHaisoMeisai.chakuchiId,
          biko: this.recHaisoMeisai.chakuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiYmd) ? this.recHaisoMeisai.chakuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiHms) ? this.recHaisoMeisai.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },
    // --------------------------------------------------------------------------------
    // 発着経由地入れ替え
    // --------------------------------------------------------------------------------
    onHatsuChakuReplace: function () {
      var tempHatsuChakuInfo = {
        hatsuchiId: this.recHaisoMeisai.hatsuchiId,
        hatsuchiBiko: this.recHaisoMeisai.hatsuchiBiko,
        keiyuchiId1: this.recHaisoMeisai.keiyuchiId1,
        keiyuchiBiko1: this.recHaisoMeisai.keiyuchiBiko1,
        keiyuchiId2: this.recHaisoMeisai.keiyuchiId2,
        keiyuchiBiko2: this.recHaisoMeisai.keiyuchiBiko2,
        keiyuchiId3: this.recHaisoMeisai.keiyuchiId3,
        keiyuchiBiko3: this.recHaisoMeisai.keiyuchiBiko3,
        keiyuchiId4: this.recHaisoMeisai.keiyuchiId4,
        keiyuchiBiko4: this.recHaisoMeisai.keiyuchiBiko4,
        keiyuchiId5: this.recHaisoMeisai.keiyuchiId5,
        keiyuchiBiko5: this.recHaisoMeisai.keiyuchiBiko5,
        chakuchiId: this.recHaisoMeisai.chakuchiId,
        chakuchiBiko: this.recHaisoMeisai.chakuchiBiko
      }

      // 既存値初期化
      this.recHaisoMeisai.hatsuchiId = null
      this.recHaisoMeisai.hatsuchiBiko = null
      this.recHaisoMeisai.keiyuchiId1 = null
      this.recHaisoMeisai.keiyuchiBiko1 = null
      this.recHaisoMeisai.keiyuchiId2 = null
      this.recHaisoMeisai.keiyuchiBiko2 = null
      this.recHaisoMeisai.keiyuchiId3 = null
      this.recHaisoMeisai.keiyuchiBiko3 = null
      this.recHaisoMeisai.keiyuchiId4 = null
      this.recHaisoMeisai.keiyuchiBiko4 = null
      this.recHaisoMeisai.keiyuchiId5 = null
      this.recHaisoMeisai.keiyuchiBiko5 = null
      this.recHaisoMeisai.chakuchiId = null
      this.recHaisoMeisai.chakuchiBiko = null

      if (![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiId)) {
        this.recHaisoMeisai.hatsuchiId = tempHatsuChakuInfo.chakuchiId
        this.recHaisoMeisai.hatsuchiBiko = tempHatsuChakuInfo.chakuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiId)) {
        this.recHaisoMeisai.chakuchiId = tempHatsuChakuInfo.hatsuchiId
        this.recHaisoMeisai.chakuchiBiko = tempHatsuChakuInfo.hatsuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId5)) {
        this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId5
        this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko5
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId4)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId4
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko4
        } else {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId4
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko4
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId3)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko3
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko3
        } else {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko3
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId2)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3)) {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko2
        } else {
          this.recHaisoMeisai.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko2
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId1)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3)) {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId4)) {
          this.recHaisoMeisai.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko1
        } else {
          this.recHaisoMeisai.keiyuchiId5 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko5 = tempHatsuChakuInfo.keiyuchiBiko1
        }
      }
    },

    row_color_class: function (item) {
      return item.delFlg === true ? 'row_delete' : ''
    },
    changeMeisaiTab (p) {
      if (p === 'tab1') {
        this.activeTab = '01'
      } else if (p === 'tab2') {
        this.activeTab = '02'
      } else if (p === 'tab3') {
        this.activeTab = '03'
      }
    },
    // --------------------------------------------------
    // IndexedDB取得
    // --------------------------------------------------
    getTeikeiInfo: function (teikeiKihonNo) {
      var teikeiCourse = this.teikeiCourseList.find((t) => {
        return t.teikeiKihonNo === teikeiKihonNo
      })
      return teikeiCourse
    },
    // 就労区分Listから、hyojiOrderが最も小さいCodeを返す。
    getShuroKbnFirstOrder: function () {
      const shuroKbnList = indexeddb.getKubunList(this.currentKaishaCode, this.kubunList, 'SFF999')
      if (shuroKbnList.length < 1) { return }
      shuroKbnList.sort((a, b) => {
        if (a.hyojiOrder > b.hyojiOrder) { return 1 }
        if (a.hyojiOrder === b.hyojiOrder) { return 0 }
        return -1
      })
      return shuroKbnList[0].code
    }
  }
}
